// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-02T21:24:47.609Z
// Property: Macallan On Ross (ID: 5646289643503616)
// Collections: 23 amenities, 17 floorplans (live), 26 photos, 80 POIs, 2 reviews, 1 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5695708787113984",
  "multihub_property_id": "5646289643503616",
  "property_external_id": "4810272",
  "property_zillow_url": "https://www.zillow.com/homedetails/3501-Ross-Ave-Dallas-TX-75204/2062040910_zpid/",
  "property_apartments_url": "https://www.apartments.com/macallan-on-ross-dallas-tx/jr1hjj4",
  "property_google_business_url": "https://www.google.com/maps/place/Macallan+at+Ross/@32.7965327,-96.7903485,17z/data=!4m13!1m7!3m6!1s0x864e98d7203b418b:0x78faf61aecb4934d!2s3501+Ross+Ave,+Dallas,+TX+75204!3b1!8m2!3d32.7965327!4d-96.7881545!3m4!1s0x864e98d71ff600e5:0x361a3f0e7f5c85b8!8m2!3d32.7964613!4d-96.7881366",
  "property_linkedin_url": null,
  "property_hubspot_id": "8443251724",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "macallan-on-ross",
  "property_name": "Macallan On Ross",
  "property_website_url": "https://www.macallanonross.com/",
  "property_domain": "https://www.macallanonross.com/",
  "property_address": "3501 Ross Ave",
  "property_full_address": "3501 Ross Ave, Dallas, TX 75204",
  "property_address_1": "3501 Ross Ave",
  "property_address_2": null,
  "property_address_city": "Dallas",
  "property_address_state": "TX",
  "property_address_zip_full": "75204-5449",
  "property_address_zip": "75204",
  "property_address_country": "US",
  "property_address_county": "Dallas County",
  "property_neighborhood_address": "Old East Dallas",
  "property_address_latitude": "32.7973558",
  "property_address_longitude": "-96.7885452",
  "property_email": "macallan@alapts.com",
  "property_phone": "(214) 821-3370",
  "property_call_tracking_phone": "817-842-2318",
  "property_company_name": "American Landmark",
  "property_company_url": "https://www.alapts.com/",
  "agency_contacts": null,
  "property_type": "apartment",
  "property_short_description": "<p><strong>Live connected on Ross Avenue.</strong> Macallan On Ross pairs studio, one-, and two-bedroom apartments with polished finishes, effortless community spaces, and a central Dallas address made for easy everyday movement. Explore the <a href=\"/floor-plans\">floor plans</a>, browse the <a href=\"/gallery\">gallery</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> today.</p>",
  "property_long_description": "<p><strong>Live connected on Ross Avenue.</strong> Macallan On Ross brings studio, one-, and two-bedroom apartments to a central Dallas setting near Cityplace, Uptown, Deep Ellum, and the Dallas Arts District. From here, you can move easily between Ross Avenue dining, West Village shopping, Lower Greenville favorites, Klyde Warren Park, and DART access at Cityplace/Uptown Station.</p><p>Inside, choose layouts with polished finishes like sleek quartz countertops, stainless steel appliances, contemporary glass tile backsplashes, in-home washer and dryer sets, walk-in closets, and select homes with plank-style wood flooring, vaulted ceilings, balconies, or private yard space. Around the community, <a href=\"/amenities\">everyday amenities</a> make downtime feel effortless: a resort-style pool plaza, professional fitness studio with yoga and cycling space, fireside lounge, cyber cafe, outdoor grilling station, EV charging, resident convenience store, and a bark park with pet spa.</p><p>Explore the <a href=\"/floor-plans\">floor plans</a>, browse the <a href=\"/gallery\">gallery</a>, and see how Macallan On Ross puts a modern apartment base in one of Dallas’s most convenient urban corridors.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019d02ef-826e-77cb-9ed0-48cc3d476508.webp",
  "property_featured_image_media": {
    "alt_text": "Courtyard swimming pool with lounge chairs and umbrellas.",
    "public_id": "019d02ef-826e-77cb-9ed0-48cc3d476508",
    "storage_key": "property/5646289643503616/019d02ef-826e-77cb-9ed0-48cc3d476508.webp",
    "width": 1240,
    "height": 827
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "368",
  "property_year_built": "2015",
  "property_year_renovated": "2022",
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "95.65217391304348",
  "property_admin_fee": "150",
  "property_application_fee": "75",
  "property_fees_deposit_info": "Application Fee $75\nAdministrative Fee $150\nNon-Refundable Pet Fee $400 / pet\nMonthly Pet Rent $20 / pet\nApplication Approval Fee Starting At $300",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "400",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "20",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions may apply. Contact us for more information.",
  "property_pet_policy_description": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $400 per pet, with a monthly pet rent of $20 per pet. Breed restrictions may apply.",
  "property_petpolicy_info": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $400 per pet, with a monthly pet rent of $20 per pet. Breed restrictions may apply.",
  "property_online_leasing_url": "https://8731695.onlineleasing.realpage.com",
  "property_resident_portal_url": "https://macallanonross.loftliving.com/login",
  "property_apply_now_url": "https://8731695.onlineleasing.realpage.com",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019e6fd4-d78b-77aa-b4ec-deeac1a9a09e.webp",
  "property_primary_logo_media": {
    "alt_text": "Macallan On Ross Premier Apartments logo",
    "public_id": "019e6fd4-d78b-77aa-b4ec-deeac1a9a09e",
    "storage_key": "property/5646289643503616/019e6fd4-d78b-77aa-b4ec-deeac1a9a09e.webp",
    "width": 1901,
    "height": 1118
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019e6fd4-d848-753c-9ded-431524d69dfa.webp",
  "property_secondary_logo_media": {
    "alt_text": "Macallan On Ross Premier Apartments logo.",
    "public_id": "019e6fd4-d848-753c-9ded-431524d69dfa",
    "storage_key": "property/5646289643503616/019e6fd4-d848-753c-9ded-431524d69dfa.webp",
    "width": 1901,
    "height": 1126
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019e6fd4-d5a5-728f-807e-259ed0ecbd0a.webp",
  "property_icon_media": {
    "alt_text": "The letter M inside a maroon circular emblem.",
    "public_id": "019e6fd4-d5a5-728f-807e-259ed0ecbd0a",
    "storage_key": "property/5646289643503616/019e6fd4-d5a5-728f-807e-259ed0ecbd0a.webp",
    "width": 536,
    "height": 536
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019e6fd4-d5a5-728f-807e-259ed0ecbd0a.webp",
  "property_fav_icon_media": {
    "alt_text": "The letter M inside a maroon circular emblem.",
    "public_id": "019e6fd4-d5a5-728f-807e-259ed0ecbd0a",
    "storage_key": "property/5646289643503616/019e6fd4-d5a5-728f-807e-259ed0ecbd0a.webp",
    "width": 536,
    "height": 536
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019e6fd4-d8a5-766c-a752-493ccdce79e0.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Macallan On Ross logo",
    "public_id": "019e6fd4-d8a5-766c-a752-493ccdce79e0",
    "storage_key": "property/5646289643503616/019e6fd4-d8a5-766c-a752-493ccdce79e0.webp",
    "width": 1901,
    "height": 1016
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f42ee-8f4e-7098-8ae1-2d64048a38d2.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019f42ee-8f4e-7098-8ae1-2d64048a38d2",
    "storage_key": "property/5646289643503616/019f42ee-8f4e-7098-8ae1-2d64048a38d2.webp",
    "width": 1280,
    "height": 752
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-af4c-707a-be5f-eaefee6b31cf.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
  "property_company_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-c9dc-7579-9b73-fbe42f847d6f",
    "storage_key": "company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
    "width": 1968,
    "height": 884
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-b73c-7581-ab8a-b01c3434f867",
    "storage_key": "company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
    "width": 2565,
    "height": 1000
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "American Landmark logo on a black background",
    "public_id": "019d02ed-bfec-74fd-b5d0-5a699636306b",
    "storage_key": "company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
    "width": 2565,
    "height": 1000
  },
  "property_primary_color": "#8b2233",
  "property_secondary_color": "#cc9f52",
  "property_font_color": "#2e2a25",
  "property_color_4": null,
  "property_color_3": "#0b2a4a",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "studio - 2",
  "property_bedrooms_min": "studio",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "504 - 1173",
  "property_sqft_min": "504",
  "property_sqft_max": "1173",
  "property_price_range": "1215.33 - 2011.66",
  "property_price_min": "1215.33",
  "property_price_max": "2011.66",
  "property_available_units": 16,
  "property_facebook_url": "https://www.facebook.com/MacallanOnRoss",
  "property_instagram_url": "https://www.instagram.com/macallanonross",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ5QD2H9eYToYRuIVcfw4_GjY",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/macallan-on-ross-dallas-2",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": null,
  "property_home_amenities_blurb": "<p><strong>Everyday ease, polished for Ross Avenue.</strong> Macallan On Ross brings the details together with Fetch package service, EV charging, elevator access, a resident convenience store, and 24/7 online resident tools. Unwind at the resort-style pool plaza, grill station, fireside lounge, or fitness studio with yoga and cycling space—then come home to quartz countertops, stainless steel appliances, full-size washers and dryers, keyless entry, and pet-friendly perks like a bark park and posh pet spa.</p>",
  "property_home_floorplans_blurb": "<p><strong>Choose the space that fits your routine.</strong> Macallan On Ross offers studio, one-bedroom, and two-bedroom apartments in Dallas with smart options for openness, storage, and separation. Select homes add polished finishes like quartz countertops, stainless steel appliances, glass tile backsplashes, walk-in closets, in-home washer and dryer, plus available vaulted ceilings, balconies, or yard space.</p>",
  "property_home_gallery_blurb": "<p><strong>Picture Macallan On Ross from every angle.</strong> Preview quartz-topped kitchens with glass tile, roomy islands, and clean modern finishes, then swipe to wood-style flooring, vaulted ceilings, balconies, and yard space in select homes. The gallery also brings the pool courtyard, fire pit seating, grill station, fitness studio, cyber cafe, lounge areas, and resident store into view before you visit.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Ross Avenue puts Dallas in motion.</strong> From Macallan On Ross, step into Cityplace energy with coffee spots, patio dining, daily errands, and nights out close to home. Exall Park, West Village, Henderson Avenue, and Cityplace/Uptown Station keep green space, open-air shopping, local restaurants, DART, and the M-Line Trolley within easy reach—then return to a gated, pet-friendly community designed for relaxing and recharging.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents say it best.</strong> Reviews for Macallan On Ross spotlight the friendly team, responsive maintenance, and social calendar with pool parties, wine tastings, and more. Add in an “amazing” pool, fitness spaces, spacious layouts, and easy access to Dallas dining, parks, museums, and major roadways, and it’s easy to see why one review says, “everything you need is here.”</p>",
  "property_neighborhood_blurb": "<p><strong>Start with Ross Avenue energy, then choose your direction.</strong> From Macallan On Ross, Cityplace puts you close to the everyday rhythm that makes this part of Dallas feel alive: patio dinners, coffee runs, quick errands, and easy nights out without leaving the urban core.</p><p>Walk the map and you will see how naturally the area connects—Exall Park for a green break, West Village for open-air shopping and restaurants, Henderson Avenue for local dining, and Cityplace/Uptown Station for DART and M-Line Trolley access toward McKinney Avenue, Klyde Warren Park, and the Arts District. When the day winds down, come back to a gated, pet-friendly apartment community with spaces built for relaxing, recharging, and getting back out again. Ready to see the neighborhood from here? <a href=\"/schedule-a-tour\">Schedule a tour</a>.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Ease is built into the details.</strong> At Macallan On Ross, amenities support the way your day actually moves—from Fetch package service and 24/7 online resident tools to EV charging, elevator access, and a resident convenience store. When it is time to reset, you can move between the resort-style pool plaza, outdoor grill station, fireside lounge, social lounge, and professional fitness studio with yoga and cycling space.</p><p>Inside, polished finishes keep the experience just as thoughtful: sleek quartz countertops, stainless steel appliances, glass tile backsplashes, in-home full-size washers and dryers, keyless door entry, and select homes with 10-foot vaulted ceilings, plank-style flooring, or yard space. Pet-friendly perks include a bark park and posh pet spa—then explore more in the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_applynow_blurb": "<p><strong>Ready to make Macallan On Ross home?</strong><br>Start your application online for a modern Dallas apartment with polished finishes, in-home laundry, and access to effortless community spaces—all in a connected Ross Avenue setting built for easy everyday living.</p>",
  "property_contactus_blurb": "<p><strong>Connect with Macallan On Ross.</strong> Have a question about our studio, one-, or two-bedroom apartments, polished in-home finishes, or central Ross Avenue location? Reach out to the leasing team for details, directions, or help planning your next visit.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Macallan On Ross?</strong> Start here for quick answers about the community, leasing details, apartment features, amenities, and everyday living on Ross Avenue. If you need anything more specific, the leasing team is happy to help you take the next step.</p>",
  "property_floorplans_blurb": "<p><strong>Find the layout that fits your day.</strong> Macallan On Ross offers studio, one-bedroom, and two-bedroom apartments in Dallas, giving you room to choose the balance of openness, storage, and separation that feels right. Start with an efficient studio, step into a one-bedroom with extra breathing room, or compare two-bedroom layouts with paired baths for added flexibility.</p><p>Inside select homes, details like sleek quartz countertops, stainless steel appliances, contemporary glass tile backsplashes, walk-in closets, in-home washer and dryer convenience, and options such as vaulted ceilings, balconies, or yard space help each floor plan feel polished and practical. Browse current availability, compare pricing, and use the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see how your favorite layout lives in person.</p>",
  "property_gallery_blurb": "<p><strong>See the style before you step inside.</strong> Browse photos of Macallan On Ross apartments and move from polished interiors to inviting shared spaces in a few swipes. Notice kitchens with quartz counters, glass tile, and roomy islands. Then look closer at living areas with ceiling fans, clean finishes, and select details like wood-style flooring, vaulted ceilings, balconies, or yard space.</p><p>Outdoors, the gallery captures the pool courtyard, fire pit seating, grill station, and shaded places to unwind; inside, you will find the fitness studio, lounge spaces, cyber cafe, and resident store. If a photo sparks a favorite, compare <a href=\"/floor-plans\">available layouts</a>, explore more <a href=\"/amenities\">amenity details</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see Macallan On Ross in Cityplace in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Macallan On Ross on the map.</strong> See available apartments in a central Dallas setting, then scan nearby dining, shopping, parks, and DART access around Ross Avenue. Use the interactive map to connect <a href=\"/floor-plans\">floor plans</a> with the neighborhood conveniences that shape everyday life here.</p>",
  "property_pets_blurb": "<p><strong>Four paws have room to feel at home.</strong> At Macallan On Ross, cats and dogs are welcome with pet-friendly living woven into the everyday experience. Head to the <a href=\"/amenities\">private bark park and posh pet spa</a> for playtime, rinse-offs, and a smoother post-walk routine, then come back to comfortable apartment features like in-home washer and dryer convenience, hard-surface flooring in select homes, and optional private yard space in select layouts.</p><p>Set in Cityplace, this Dallas apartment community keeps pet care practical without giving up the polished extras you want at home. Have questions about pet guidelines, available homes, or breed restrictions? <a href=\"/contact-us\">Contact the leasing team</a> and find the right fit for you and your companion.</p>",
  "property_referafriend_blurb": "<p><strong>Share life connected on Ross Avenue.</strong> Love your modern apartment base, polished finishes, and effortless downtime at Macallan On Ross? Invite a friend to discover the same central Dallas convenience and everyday comfort—send a referral and help them find their place here.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident access, made easy.</strong><br>Manage life at Macallan On Ross from one convenient place—pay rent, submit maintenance requests, and keep your account current while staying connected to your modern Ross Avenue apartment base.</p>",
  "property_reviews_blurb": "<p><strong>See what residents are saying.</strong> As you read the reviews for Macallan On Ross, you’ll notice recurring praise for the friendly team, attentive maintenance, and a community calendar filled with ways to connect, from pool parties to wine tastings.</p><p>Residents also call out the “amazing” pool, well-equipped fitness spaces, spacious layouts, and easy access to Dallas dining, parks, museums, and major roadways. One reviewer summed it up as “everything you need is here”—a helpful snapshot of the lifestyle current residents describe.</p>",
  "property_created_at": "1752256384547",
  "property_scheduletour_blurb": "<p><strong>See Macallan On Ross in person.</strong> Tour studio, one-, and two-bedroom apartments with quartz countertops, stainless steel appliances, in-home washer and dryer sets, and select layouts with balconies or private yard space. Then get a feel for the pool plaza, fitness studio, and effortless Ross Avenue setting.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you for reaching out.</strong><br>Your inquiry has been received, and the leasing team will follow up soon. In the meantime, picture life at Macallan On Ross: modern studio, one-, and two-bedroom apartments with polished finishes, effortless amenities, and a connected Ross Avenue address in central Dallas.</p>",
  "property_virtualtours_blurb": "<p><strong>Walk through the spaces before you arrive.</strong> Explore Macallan On Ross at your own pace with virtual tours that move beyond still photos and into the details: the community setting, clubhouse, and fitness center, plus walkthroughs of the A4 one-bedroom and B1 two-bedroom apartment layouts. Pause in the clubhouse to picture the lounge experience, scan the fitness equipment and studio space, then step inside apartment interiors to compare open living areas, island kitchens, modern finishes, storage, and bedroom separation. It is an easy way to narrow your favorites from wherever you are before you browse <a href=\"/floor-plans\">current floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> for a closer look.</p>",
  "property_copyright": "2025 All Rights Reserved. Macallan On Ross",
  "property_seo_title_home": "Macallan On Ross | Apartments in Dallas, TX",
  "property_seo_description_home": "Discover your perfect home at Macallan On Ross in Dallas, TX! Explore our range of floor plans including stylish studios, welcoming one-bedroom, and spacious two-bedroom apartments. Enjoy top-notch amenities such as a pool, fitness center, dog park, and LUXER package lockers, all in a smoke-free community. With features like hard floors, tall ceilings, and custom master closet organizers, comfort meets convenience. Don't miss out on our technology package and online resident services. Find your new home today and experience the vibrant lifestyle that awaits you!",
  "property_seo_title_floorplans": "Floor Plans | studio - 2 Apartments in Dallas, TX",
  "property_seo_description_floorplans": "Discover your ideal living space at Macallan On Ross in Dallas, TX! Explore our diverse selection of floor plans, including stylish studios, spacious one-bedroom, and accommodating two-bedroom apartments. Browse our available apartment homes today and find the perfect fit for your lifestyle!",
  "property_seo_title_amenities": "Amenities | Dallas, TX Apartments for Rent",
  "property_seo_description_amenities": "Discover Macallan On Ross in Dallas, TX, where luxury meets convenience! Explore our thoughtfully designed floor plans, including one-bedroom, studio, and two-bedroom options. Enjoy top-notch amenities like a state-of-the-art fitness center, refreshing pool, and a relaxing dog park. With features such as LUXER Package Lockers, car charging stations, and online resident services, every aspect of your living experience is catered for. Don’t miss out—explore our amazing community amenities and apartment features today!",
  "property_seo_title_gallery": "Gallery | Apartments in Dallas, TX",
  "property_seo_description_gallery": "Explore the vibrant lifestyle at Macallan On Ross in Dallas, TX! Dive into our stunning photo gallery showcasing spacious floor plans, including one-bedroom, studio, and two-bedroom apartments. Enjoy top-notch amenities like a fitness center, dog park, and luxurious pool, all within a smoke-free community. Picture yourself living in modern homes featuring technology packages, custom closet organizers, and breathtaking views. Don't wait—discover your perfect apartment today!",
  "property_seo_title_virtualtours": "Virtual Tours | Macallan On Ross Apartments",
  "property_seo_description_virtualtours": "Explore Macallan On Ross in Dallas, TX! Discover our diverse floor plans, including Studio, One Bedroom, and Two Bedroom apartments, designed for your lifestyle. Take a virtual tour of our vibrant community and find your perfect home today!",
  "property_seo_title_interactivemap": "Interactive Map | Macallan On Ross Apartments",
  "property_seo_description_interactivemap": "Discover your perfect home at Macallan On Ross in Dallas, TX! Choose from a variety of thoughtfully designed floor plans, including stylish studios, one-bedroom, and spacious two-bedroom options. Enjoy luxurious amenities such as a resort-style pool, state-of-the-art fitness center, dog park, and convenient LUXER package lockers. Experience modern living with high-end finishes, online resident services, and a vibrant community atmosphere. Explore our interactive community map to find available apartments, view pricing, and take the first step towards your new lifestyle!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Dallas, TX",
  "property_seo_description_neighborhood": "Discover the vibrant neighborhood surrounding Macallan On Ross in Dallas, TX! Explore our one-bedroom, studio, and two-bedroom floor plans while immersing yourself in local favorites and nearby attractions. See what's around our community and start your new adventure today!",
  "property_seo_title_contact": "Contact Us | Macallan On Ross",
  "property_seo_description_contact": "Discover your perfect home at Macallan On Ross in Dallas, TX! Explore our diverse floor plans, including stylish studios, cozy one-bedroom apartments, and spacious two-bedroom options. Have questions? Our friendly leasing team is ready to assist you—contact us today to learn more!",
  "property_seo_title_faqs": "FAQs | Apartments in Dallas, TX",
  "property_seo_description_faqs": "Discover your ideal living space at Macallan On Ross in Dallas, TX! Choose from stylish floor plans including one-bedroom, studios, and two-bedroom apartments, all equipped with modern amenities like a comprehensive fitness center, LUXER Package Locker, and a relaxing pool. Enjoy perks such as a dog park, car charging stations, and an inviting fire pit. Curious about our community? Browse our FAQs page for all your questions and learn more about life at Macallan On Ross today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Dallas, TX",
  "property_seo_description_reviews": "Discover life at Macallan On Ross in Dallas, TX! Choose from stylish floor plans including studio, one, and two-bedroom apartments with amenities like a state-of-the-art fitness center, relaxing pool, and dog park. Enjoy added convenience with our LUXER package locker, online resident services, and resident convenience store. Experience vibrant living with beautiful views and custom features like tall ceilings and kitchen islands. Curious about what our residents think? Read their reviews and see what makes our smoke-free community the perfect place to call home!",
  "property_seo_title_applynow": "Apply Now | Apartments in Dallas, TX",
  "property_seo_description_applynow": "Discover your ideal living space at Macallan On Ross in Dallas, TX! Our community offers a range of floor plans, including one-bedroom, studio, and two-bedroom layouts, to suit your lifestyle. Enjoy exceptional amenities such as a sparkling pool, modern fitness center, and dog park—all in a smoke-free environment. With online resident services, car charging stations, and high-tech convenience, living here is a breeze. Explore our captivating views and stylish interiors, then find your perfect home and lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Macallan On Ross",
  "property_seo_description_residentaccess": "\"Welcome to Macallan On Ross in Dallas, TX! Access your resident portal effortlessly to pay rent, schedule maintenance, and enjoy exclusive community updates. Log in now for a seamless living experience!\"",
  "property_seo_title_referafriend": "Refer A Friend | Macallan On Ross",
  "property_seo_description_referafriend": "\"Refer a friend to Macallan On Ross in Dallas, TX, and enjoy a vibrant community where great friends become great neighbors! Discover exciting rewards and a welcoming atmosphere. Start building your ideal living experience today!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Macallan On Ross",
  "property_seo_description_scheduletour": "\"Experience luxury living at Macallan On Ross in Dallas, TX! Schedule a tour of our stunning apartment community today and discover exceptional amenities, spacious layouts, and vibrant neighborhood living. Your new home awaits!\"",
  "property_seo_title_privacy": "Privacy Policy | Macallan On Ross",
  "property_seo_description_privacy": "Discover the privacy standards at Macallan On Ross in Dallas, TX. Your trust is our priority. Explore how we protect your information and ensure your peace of mind. View our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | Macallan On Ross",
  "property_seo_description_accessibility": "\"Discover Macallan On Ross in Dallas, TX, where digital inclusion is a priority! Explore our accessibility statement to see how we ensure all residents and visitors enjoy a seamless experience. Join our community today!\"",
  "property_seo_title_sitemap": "Sitemap | Macallan On Ross",
  "property_seo_description_sitemap": "\"Discover Macallan On Ross in Dallas, TX! Explore our comprehensive sitemap to navigate our vibrant community, view available apartments, and learn about amenities. Your ideal home awaits—click to view now!\"",
  "property_seo_title_thankyou": "Thank You | Macallan On Ross",
  "property_seo_description_thankyou": "\"Thank you for reaching out to Macallan On Ross in vibrant Dallas, TX! Your information has been received, and a member of our team will connect with you shortly. Discover your perfect apartment home with us!\"",
  "property_seo_title_pets": "Pet Policy | Apartments in Buford, GA\r",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791234320000",
  "amenities": [
    {
      "id": "custom_bfd7c35c-6d83-41f3-9f36-1a499ddfcd6c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "custom",
      "external_id": "P000000597",
      "title": "American Landmark 360",
      "amount": "0.0000",
      "description": "American Landmark 360 Resident Program",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4ba52fc4-8569-4e4e-8168-b1cbf2522d9b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "custom",
      "external_id": "P000000609",
      "title": "Cabinets",
      "amount": "0.0000",
      "description": "Craftsman-Style Cabinetry w/Glass Doors",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d6da9757-f310-42e9-af12-2804849d5ac2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "custom",
      "external_id": "P000000610",
      "title": "Car Charging Stations",
      "amount": "0.0000",
      "description": "Electric Car Charging Stations",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e8985afd-0163-487b-986c-8f0499c4b190",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "custom",
      "external_id": "P000000621",
      "title": "Counters",
      "amount": "0.0000",
      "description": "Sleek Quartz Countertops",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cfd49b4f-8e19-418d-95b7-6099ae5a385f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "custom",
      "external_id": "P000000626",
      "title": "Dog Park",
      "amount": "0.0000",
      "description": "Private Bark Park & Posh Pet Spa",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b23a1556-8ea0-4b91-8cf7-84d4fbbe949f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "custom",
      "external_id": "P000000630",
      "title": "Elevators",
      "amount": "0.0000",
      "description": "Elevator Access",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_aab6dccb-967d-49f9-ab23-9ea36675530e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "custom",
      "external_id": "P000000632",
      "title": "Fenced Yard",
      "amount": "0.0000",
      "description": "Private Yard Space*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0fa2866c-7df0-458a-b17a-0909a86f4423",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "custom",
      "external_id": "P000000634",
      "title": "Fire Pit",
      "amount": "0.0000",
      "description": "Community Fire Side Lounge",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2576ffcb-428a-46fa-bfc1-f0fe5aa4b63e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "custom",
      "external_id": "P000000635",
      "title": "Fitness Center",
      "amount": "0.0000",
      "description": "Fitness Studio w/ Yoga & Cycling Studio",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_401075a7-10dc-4ba7-bad8-e1f425952fb0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "custom",
      "external_id": "P000000644",
      "title": "Grill Area",
      "amount": "0.0000",
      "description": "Outdoor Grill Station",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8fabe4f7-2483-44d3-a496-0bd21270eecf",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "custom",
      "external_id": "P000000646",
      "title": "Hard Floors",
      "amount": "0.0000",
      "description": "Plank-Style Wood Flooring*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_31a57009-d390-4dc7-bf8c-3c6725c8c316",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "custom",
      "external_id": "P000000651",
      "title": "Kitchen Appliances",
      "amount": "0.0000",
      "description": "Stainless Steel Appliances",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0cdaf452-9c57-4514-8f64-587432852508",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "custom",
      "external_id": "P000000660",
      "title": "Online Resident Services",
      "amount": "0.0000",
      "description": "Convenient 24/7 Online Resident Services",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4f496825-58df-4618-961d-43e15594cab0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "custom",
      "external_id": "P000000669",
      "title": "Pool",
      "amount": "0.0000",
      "description": "Resort Pool Plaza",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_73b0a7bf-0ceb-4f95-8495-45b8ae949729",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "custom",
      "external_id": "P000000675",
      "title": "Select Homes",
      "amount": "0.0000",
      "description": "*In Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_901ea148-293b-4209-8812-ea0b52c9656c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "custom",
      "external_id": "P000000679",
      "title": "Smoke Free Community",
      "amount": "0.0000",
      "description": "Smoke Free Community",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a72590de-cd32-4595-a039-0087941a066d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "custom",
      "external_id": "P000000690",
      "title": "Tall Ceilings",
      "amount": "0.0000",
      "description": "Vaulted 10-Foot Ceilings",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5690465a-6d96-4d69-b2e3-f271de18c44a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "custom",
      "external_id": "P000000691",
      "title": "Technology Package",
      "amount": "0.0000",
      "description": "Wifi & Cable Technology Package",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7290a2f4-0738-4063-ac16-c66750b6d3e6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "custom",
      "external_id": "P000000695",
      "title": "Tile Backsplash",
      "amount": "0.0000",
      "description": "Contemporary Glass Tile Backsplash",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8b1e9837-cc9d-4326-8dc5-324cb8e85b14",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "custom",
      "external_id": "P000000704",
      "title": "W&D Included",
      "amount": "0.0000",
      "description": "In-Home Full-Size Washer & Dryer/Stackable",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0eb0f58e-dfed-413b-b13c-f3de48b4472d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "custom",
      "external_id": "P000001372",
      "title": "Lounge",
      "amount": "0.0000",
      "description": "Social Lounge",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_23b423a3-b5e4-47ca-8849-64ec2d69c84e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "custom",
      "external_id": "P000002334",
      "title": "Resident Convenience Store",
      "amount": "0.0000",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b57aaaa6-1dea-4f5b-89a3-b9670203194f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "custom",
      "external_id": "P000002384",
      "title": "Cyber Cafe",
      "amount": "0.0000",
      "description": "Fully Equipped Cyber Caf",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_88545f4b-e29b-4ff9-9a50-bdbaf3b164dd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019e89a1-1a4a-7236-a977-6712edb3f4d6.webp",
      "image_media": {
        "alt_text": "Modern apartment complex courtyard with a large swimming pool and lounge chairs.",
        "public_id": "019e89a1-1a4a-7236-a977-6712edb3f4d6",
        "storage_key": "property/5646289643503616/019e89a1-1a4a-7236-a977-6712edb3f4d6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind by the sparkling swimming pool at our luxury apartment community, surrounded by comfortable lounge chairs and lush landscaping.",
      "link": "",
      "alt_text": "Modern apartment complex courtyard with a large swimming pool and lounge chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_78fa411f-cadb-4a98-bb08-ff7938a98a89",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019e89a1-0fae-715a-bd23-63515252b8f5.webp",
      "image_media": {
        "alt_text": "Convenience store with refrigerated drinks and snacks.",
        "public_id": "019e89a1-0fae-715a-bd23-63515252b8f5",
        "storage_key": "property/5646289643503616/019e89a1-0fae-715a-bd23-63515252b8f5.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "A well-stocked convenience store featuring a wide selection of chilled beverages and assorted snacks, perfect for residents on the go.",
      "link": "",
      "alt_text": "Convenience store with refrigerated drinks and snacks.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c866ba83-0e01-4e86-be18-8e177facc75c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019e89a1-175e-775b-adfb-f0e871acb6b1.webp",
      "image_media": {
        "alt_text": "Washer and dryer with overhead cabinets in a laundry room.",
        "public_id": "019e89a1-175e-775b-adfb-f0e871acb6b1",
        "storage_key": "property/5646289643503616/019e89a1-175e-775b-adfb-f0e871acb6b1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "In-unit washer and dryer with convenient overhead storage for laundry supplies.",
      "link": "",
      "alt_text": "Washer and dryer with overhead cabinets in a laundry room.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_59d72f10-dd68-48d2-a80e-c53cf4a549fa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019e89a1-0eb3-70d7-8869-4f6a59c36e2a.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and a large island.",
        "public_id": "019e89a1-0eb3-70d7-8869-4f6a59c36e2a",
        "storage_key": "property/5646289643503616/019e89a1-0eb3-70d7-8869-4f6a59c36e2a.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Gourmet kitchen featuring dark wood cabinetry, granite countertops, stainless steel appliances, and a spacious island perfect for entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and a large island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c2a9080e-7f63-4c6a-b3ed-75ffcabff670",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019e89a1-0d2b-76db-a1dd-28c689d2b825.webp",
      "image_media": {
        "alt_text": "Kitchen island with sink and seating area, open to living room with sofa and coffee table.",
        "public_id": "019e89a1-0d2b-76db-a1dd-28c689d2b825",
        "storage_key": "property/5646289643503616/019e89a1-0d2b-76db-a1dd-28c689d2b825.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Modern open-concept living space featuring a sleek kitchen island and a comfortable living room, perfect for entertaining.",
      "link": "",
      "alt_text": "Kitchen island with sink and seating area, open to living room with sofa and coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_39f0bddd-62d8-42af-8d29-9bc5f089d502",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019e89a0-ffb0-776d-9917-4e1d9bbf8900.webp",
      "image_media": {
        "alt_text": "Modern lounge area with comfortable seating and large screen TVs.",
        "public_id": "019e89a0-ffb0-776d-9917-4e1d9bbf8900",
        "storage_key": "property/5646289643503616/019e89a0-ffb0-776d-9917-4e1d9bbf8900.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish resident lounge, featuring plush seating, large screen TVs, and a contemporary ambiance perfect for socializing or quiet contemplation.",
      "link": "",
      "alt_text": "Modern lounge area with comfortable seating and large screen TVs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6ac563c5-a31e-49b4-90f2-c42b2cbdc764",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019e89a1-0192-735c-bf61-7b9b94ba33de.webp",
      "image_media": {
        "alt_text": "Modern bathroom with dark vanity, large mirror, toilet, and walk-in closet.",
        "public_id": "019e89a1-0192-735c-bf61-7b9b94ba33de",
        "storage_key": "property/5646289643503616/019e89a1-0192-735c-bf61-7b9b94ba33de.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Step into a spa-like experience in this beautifully appointed bathroom, featuring a spacious vanity, elegant fixtures, and a convenient walk-in closet for all your storage needs.",
      "link": "",
      "alt_text": "Modern bathroom with dark vanity, large mirror, toilet, and walk-in closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0b4ceffa-cc7d-44ed-98b1-c7fe6d422576",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019e89a1-025b-75ae-8058-4e4ec584ba06.webp",
      "image_media": {
        "alt_text": "Outdoor kitchen with grills and bar seating.",
        "public_id": "019e89a1-025b-75ae-8058-4e4ec584ba06",
        "storage_key": "property/5646289643503616/019e89a1-025b-75ae-8058-4e4ec584ba06.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy cooking and dining al fresco at the community's outdoor kitchen and bar area.",
      "link": "",
      "alt_text": "Outdoor kitchen with grills and bar seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8f40ecad-d544-4916-ad9e-87bdc06362ae",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019e89a0-fd75-729f-9308-07799e7fe2af.webp",
      "image_media": {
        "alt_text": "Living room with sectional sofa, accent chairs, and view into bedroom.",
        "public_id": "019e89a0-fd75-729f-9308-07799e7fe2af",
        "storage_key": "property/5646289643503616/019e89a0-fd75-729f-9308-07799e7fe2af.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious living area with modern furnishings, large sectional sofa, and a glimpse into the comfortable bedroom.",
      "link": "",
      "alt_text": "Living room with sectional sofa, accent chairs, and view into bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_083c608e-1ce1-4450-9177-c7e451db1d6d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019e89a1-00c4-766c-8a9c-bbc59138fe6b.webp",
      "image_media": {
        "alt_text": "Outdoor courtyard with fire pit and seating",
        "public_id": "019e89a1-00c4-766c-8a9c-bbc59138fe6b",
        "storage_key": "property/5646289643503616/019e89a1-00c4-766c-8a9c-bbc59138fe6b.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Gather around the fire pit in the community courtyard, perfect for relaxing evenings and socializing.",
      "link": "",
      "alt_text": "Outdoor courtyard with fire pit and seating",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_95f17489-bbea-49e0-909e-5ce88695a2ee",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019e89a0-fbdf-742c-a952-f82099a5d1ce.webp",
      "image_media": {
        "alt_text": "Modern apartment building exterior with a swimming pool and fire pit area.",
        "public_id": "019e89a0-fbdf-742c-a952-f82099a5d1ce",
        "storage_key": "property/5646289643503616/019e89a0-fbdf-742c-a952-f82099a5d1ce.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy outdoor living with our sparkling swimming pool and a cozy fire pit area, perfect for relaxing evenings.",
      "link": "",
      "alt_text": "Modern apartment building exterior with a swimming pool and fire pit area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_167f824d-4726-4a61-8702-d26725f9f71c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019e89a0-f9e8-7759-89e7-c40f3d8560b1.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, dark wood cabinets, and a breakfast bar with two stools.",
        "public_id": "019e89a0-f9e8-7759-89e7-c40f3d8560b1",
        "storage_key": "property/5646289643503616/019e89a0-f9e8-7759-89e7-c40f3d8560b1.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Gourmet kitchen featuring stainless steel appliances, ample cabinet space, and a sleek breakfast bar perfect for casual dining.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, dark wood cabinets, and a breakfast bar with two stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5bdee391-04e2-4347-bd85-5cdc35a30367",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019e89a0-f28c-76a3-a547-6f667717fae0.webp",
      "image_media": {
        "alt_text": "Gym with weight machines and exercise balls",
        "public_id": "019e89a0-f28c-76a3-a547-6f667717fae0",
        "storage_key": "property/5646289643503616/019e89a0-f28c-76a3-a547-6f667717fae0.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Fully equipped fitness center with state-of-the-art weight machines, cardio equipment, and free weights for residents.",
      "link": "",
      "alt_text": "Gym with weight machines and exercise balls",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_30817a34-bbd2-4195-b26a-59e852861227",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019e89a0-f127-7219-a7ac-6b1fd2dd37e5.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, ellipticals, and a stationary bike.",
        "public_id": "019e89a0-f127-7219-a7ac-6b1fd2dd37e5",
        "storage_key": "property/5646289643503616/019e89a0-f127-7219-a7ac-6b1fd2dd37e5.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring cardio equipment and a spin bike, perfect for residents to maintain an active lifestyle.",
      "link": "",
      "alt_text": "Gym with treadmills, ellipticals, and a stationary bike.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e7e76bf8-f05e-4237-abde-cf2091e0909b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019e89a0-f143-731d-81df-600be86a9825.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a king-size bed, nightstands, and large windows.",
        "public_id": "019e89a0-f143-731d-81df-600be86a9825",
        "storage_key": "property/5646289643503616/019e89a0-f143-731d-81df-600be86a9825.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in this beautifully appointed bedroom, featuring a comfortable king-size bed and ample natural light.",
      "link": "",
      "alt_text": "Cozy bedroom with a king-size bed, nightstands, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_dae821cc-917d-4170-aa31-836de481e349",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019e89a0-e33c-75db-9503-af19316ccecd.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a soaking tub, glass-enclosed shower, vanity, and toilet.",
        "public_id": "019e89a0-e33c-75db-9503-af19316ccecd",
        "storage_key": "property/5646289643503616/019e89a0-e33c-75db-9503-af19316ccecd.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Apartment",
      "description": "Relax and unwind in this luxurious bathroom featuring a deep soaking tub, a sleek glass-enclosed shower, and a spacious vanity with modern fixtures.",
      "link": "",
      "alt_text": "Modern bathroom with a soaking tub, glass-enclosed shower, vanity, and toilet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9ac130f8-36c5-4d88-be0b-edfadaf6c0bb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019e89a0-de37-7168-a7fc-d791dfe82a9d.webp",
      "image_media": {
        "alt_text": "Exterior view of a large, modern apartment building with red and gray accents and balconies.",
        "public_id": "019e89a0-de37-7168-a7fc-d791dfe82a9d",
        "storage_key": "property/5646289643503616/019e89a0-de37-7168-a7fc-d791dfe82a9d.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Discover luxurious living at this contemporary apartment community, featuring a striking architectural design and abundant resident amenities.",
      "link": "",
      "alt_text": "Exterior view of a large, modern apartment building with red and gray accents and balconies.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_94560a05-52ba-45be-b44a-a504ee64c89b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019e89a0-de7b-7101-b05e-e3b439affd89.webp",
      "image_media": {
        "alt_text": "Modern lounge area with a blue velvet sofa and accent chairs.",
        "public_id": "019e89a0-de7b-7101-b05e-e3b439affd89",
        "storage_key": "property/5646289643503616/019e89a0-de7b-7101-b05e-e3b439affd89.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax in the stylish lounge area, featuring a vibrant blue sofa, comfortable seating, and contemporary decor. Perfect for socializing or unwinding.",
      "link": "",
      "alt_text": "Modern lounge area with a blue velvet sofa and accent chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7beae589-318d-4fd0-a5ea-fa22e293d8ff",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019e89a0-dcbd-77a2-979a-4f37cf2dae20.webp",
      "image_media": {
        "alt_text": "Courtyard swimming pool with lounge chairs and umbrellas.",
        "public_id": "019e89a0-dcbd-77a2-979a-4f37cf2dae20",
        "storage_key": "property/5646289643503616/019e89a0-dcbd-77a2-979a-4f37cf2dae20.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax by the resort-style swimming pool surrounded by comfortable lounge chairs and shaded by umbrellas. Perfect for soaking up the sun or enjoying a cool dip.",
      "link": "",
      "alt_text": "Courtyard swimming pool with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3fa8e367-bd76-41cb-a7e6-afdafd58dcee",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019e89a0-ddd3-74e1-86e4-fa696a1434a0.webp",
      "image_media": {
        "alt_text": "Courtyard seating area with fire pit and outdoor furniture.",
        "public_id": "019e89a0-ddd3-74e1-86e4-fa696a1434a0",
        "storage_key": "property/5646289643503616/019e89a0-ddd3-74e1-86e4-fa696a1434a0.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and unwind in our spacious courtyard, featuring comfortable seating, a fire pit, and lush landscaping. Perfect for enjoying the outdoors.",
      "link": "",
      "alt_text": "Courtyard seating area with fire pit and outdoor furniture.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_30f77c61-32db-4fa6-9ede-512c12d05fc2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019e89a0-ddc9-74df-b5f0-8d70794dc4f7.webp",
      "image_media": {
        "alt_text": "Spin bikes and rowing machines in a modern apartment fitness center.",
        "public_id": "019e89a0-ddc9-74df-b5f0-8d70794dc4f7",
        "storage_key": "property/5646289643503616/019e89a0-ddc9-74df-b5f0-8d70794dc4f7.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a variety of cardio equipment including spin bikes and rowing machines.",
      "link": "",
      "alt_text": "Spin bikes and rowing machines in a modern apartment fitness center.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2ba046ef-850a-4074-b849-2b014ba8ec0a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019e89a0-dcb1-77f9-994c-f1b1bfb4686e.webp",
      "image_media": {
        "alt_text": "Modern living room with open kitchen and dining area.",
        "public_id": "019e89a0-dcb1-77f9-994c-f1b1bfb4686e",
        "storage_key": "property/5646289643503616/019e89a0-dcb1-77f9-994c-f1b1bfb4686e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious open-concept living area featuring a modern kitchen, dining space, and comfortable seating. Perfect for entertaining.",
      "link": "",
      "alt_text": "Modern living room with open kitchen and dining area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5d4e6ed0-4413-4686-ac3b-ada91fb7e8cd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019e89a0-d67c-731a-adf2-a0a8d0dc1fa2.webp",
      "image_media": {
        "alt_text": "Modern lounge area with a coffee bar, TV, and seating.",
        "public_id": "019e89a0-d67c-731a-adf2-a0a8d0dc1fa2",
        "storage_key": "property/5646289643503616/019e89a0-d67c-731a-adf2-a0a8d0dc1fa2.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy a freshly brewed coffee in our stylish resident lounge, featuring a coffee bar, comfortable seating, and a modern aesthetic.",
      "link": "",
      "alt_text": "Modern lounge area with a coffee bar, TV, and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e02f1463-e8c7-4f58-9f90-66a2891deebd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019e89a0-d5b1-76af-a69d-aeb8ccf8df25.webp",
      "image_media": {
        "alt_text": "Luxurious bedroom with a king-size bed, plush bedding, decorative pillows, and modern artwork.",
        "public_id": "019e89a0-d5b1-76af-a69d-aeb8ccf8df25",
        "storage_key": "property/5646289643503616/019e89a0-d5b1-76af-a69d-aeb8ccf8df25.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Step into comfort in this beautifully appointed bedroom, featuring a king-size bed with luxurious linens and contemporary decor. A statement piece for any apartment.",
      "link": "",
      "alt_text": "Luxurious bedroom with a king-size bed, plush bedding, decorative pillows, and modern artwork.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a57a995e-28ed-4fa5-887d-fe8a014dc154",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019e89a0-d679-77fd-8f3f-efa75f2c30f2.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, dark wood cabinets, and a large island with seating.",
        "public_id": "019e89a0-d679-77fd-8f3f-efa75f2c30f2",
        "storage_key": "property/5646289643503616/019e89a0-d679-77fd-8f3f-efa75f2c30f2.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Gourmet kitchen featuring stainless steel appliances, ample cabinet space, and a breakfast bar island, perfect for entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, dark wood cabinets, and a large island with seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_647de949-efd8-496f-a7b4-e4a42dd93b64",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019e89a0-c87f-7073-8b4d-3a2c7d07ab40.webp",
      "image_media": {
        "alt_text": "Modern leasing office with desks and chairs.",
        "public_id": "019e89a0-c87f-7073-8b4d-3a2c7d07ab40",
        "storage_key": "property/5646289643503616/019e89a0-c87f-7073-8b4d-3a2c7d07ab40.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Stylish leasing office space with modern desks, ergonomic chairs, and decorative shelving.",
      "link": "",
      "alt_text": "Modern leasing office with desks and chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_2ffe6c8675b3f303efb363f9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "XOXO Dining Room",
      "poi_type": "Restaurants",
      "poi_address": "3121 Ross Ave, Dallas, TX 75225, USA",
      "poi_short_description": "Funky, artful restaurant & lounge offering wine, cocktails & New American cuisine, plus a garden.",
      "poi_long_description": "Funky, artful restaurant & lounge offering wine, cocktails & New American cuisine, plus a garden.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1504-38de-748a-8cb5-b8242c6e402a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-38de-748a-8cb5-b8242c6e402a",
        "storage_key": "property/5646289643503616/019f1504-38de-748a-8cb5-b8242c6e402a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.xoxodallas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17947679939679281662&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "xoxo-dining-room",
      "poi_latitude": "32.7940808",
      "poi_longitude": "-96.7908993",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 469-397-4226",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1504-af5f-71d8-9f31-b845deb4ed5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-af5f-71d8-9f31-b845deb4ed5e",
        "storage_key": "property/5646289643503616/019f1504-af5f-71d8-9f31-b845deb4ed5e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvfnVk5uZToYR_uH8ctD3Evk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "ec_33b67a7770e3c783184a5353",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "Three Sheets - Uptown",
      "poi_type": "Restaurants",
      "poi_address": "2908 McKinney Ave, Dallas, TX 75204, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1504-376a-7649-aa9b-ee591b15c225.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-376a-7649-aa9b-ee591b15c225",
        "storage_key": "property/5646289643503616/019f1504-376a-7649-aa9b-ee591b15c225.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=15094558949399763619&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "three-sheets---uptown",
      "poi_latitude": "32.7999781",
      "poi_longitude": "-96.8005846",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 214-298-3836",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1504-af5f-71d8-9f31-b845deb4ed5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-af5f-71d8-9f31-b845deb4ed5e",
        "storage_key": "property/5646289643503616/019f1504-af5f-71d8-9f31-b845deb4ed5e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyWj1yS2ZToYRo5oq3GOletE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "ec_ebf4e6a5578f18540c0f38f6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "DALHIA",
      "poi_type": "Restaurants",
      "poi_address": "3300 Ross Ave, Dallas, TX 75204, USA",
      "poi_short_description": "Trendy hangout serving international food & floral cocktails amid plant-filled surrounds.",
      "poi_long_description": "Trendy hangout serving international food & floral cocktails amid plant-filled surrounds.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1504-3da5-713d-8637-fc77a1d5f821.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-3da5-713d-8637-fc77a1d5f821",
        "storage_key": "property/5646289643503616/019f1504-3da5-713d-8637-fc77a1d5f821.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=2812863860350751686&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dalhia",
      "poi_latitude": "32.79541",
      "poi_longitude": "-96.7887507",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-aa2e-7096-a4cf-c5501d9b2e94.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-aa2e-7096-a4cf-c5501d9b2e94",
        "storage_key": "property/5646289643503616/019f1501-aa2e-7096-a4cf-c5501d9b2e94.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJpx8TIheZToYRxpO9HcdMCSc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_fc3e15f5df9a24bcdd35d0d3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "oomi Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "3510 Ross Ave Ste 100, Dallas, TX 75204, USA",
      "poi_short_description": "Culinary hub serving comfort food, including tacos, drunken noodles, and churros.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1504-3ec8-72ca-8e1d-f289771a5a01.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-3ec8-72ca-8e1d-f289771a5a01",
        "storage_key": "property/5646289643503616/019f1504-3ec8-72ca-8e1d-f289771a5a01.webp",
        "width": 1280,
        "height": 710
      },
      "poi_business_url": "http://oomikitchen.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17717568847255806974&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oomi-kitchen",
      "poi_latitude": "32.7962347",
      "poi_longitude": "-96.787601",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 469-372-0396",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-aa2e-7096-a4cf-c5501d9b2e94.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-aa2e-7096-a4cf-c5501d9b2e94",
        "storage_key": "property/5646289643503616/019f1501-aa2e-7096-a4cf-c5501d9b2e94.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJuQDaVseZToYR_qM1sP5y4fU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_dc999efcd4a35f9a41da78a0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "Southern Classic Daiquiri Factory",
      "poi_type": "Restaurants",
      "poi_address": "3030 Ross Ave, Dallas, TX 75204, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1504-34de-7455-bf8d-cefb1e2cde25.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-34de-7455-bf8d-cefb1e2cde25",
        "storage_key": "property/5646289643503616/019f1504-34de-7455-bf8d-cefb1e2cde25.webp",
        "width": 1080,
        "height": 535
      },
      "poi_business_url": "https://www.southernclassicdaiquirifactory.com/?utm_source=local&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=3389254589852925950&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "southern-classic-daiquiri-factory",
      "poi_latitude": "32.7931846",
      "poi_longitude": "-96.7914728",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 469-862-3113",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-aa2e-7096-a4cf-c5501d9b2e94.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-aa2e-7096-a4cf-c5501d9b2e94",
        "storage_key": "property/5646289643503616/019f1501-aa2e-7096-a4cf-c5501d9b2e94.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJGxCeqcOZToYR_r-LqRcNCS8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cajun_restaurant"
    },
    {
      "id": "ec_ae83acb30b53799b1e101b33",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "The Nodding Donkey",
      "poi_type": "Restaurants",
      "poi_address": "2900 Thomas Ave, Dallas, TX 75204, USA",
      "poi_short_description": "Spacious sports bar that opens up entirely onto a wide patio, with big screens & Texas pub fare.",
      "poi_long_description": "Spacious sports bar that opens up entirely onto a wide patio, with big screens & Texas pub fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1504-3b96-758c-b368-87662ae77930.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-3b96-758c-b368-87662ae77930",
        "storage_key": "property/5646289643503616/019f1504-3b96-758c-b368-87662ae77930.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.thenoddingdonkey.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15405980346547281915&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-nodding-donkey",
      "poi_latitude": "32.7965785",
      "poi_longitude": "-96.7968317",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 214-922-8898",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1504-af5f-71d8-9f31-b845deb4ed5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-af5f-71d8-9f31-b845deb4ed5e",
        "storage_key": "property/5646289643503616/019f1504-af5f-71d8-9f31-b845deb4ed5e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBTrHJSmZToYR-5-ZNIAJzdU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_bar"
    },
    {
      "id": "ec_1ebe7cb4eea2aa044c477098",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "Rebel & Rose Neighborhood Bar",
      "poi_type": "Restaurants",
      "poi_address": "2916 McKinney Ave, Dallas, TX 75204, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1504-3832-7514-b15e-f718d4d9e7da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-3832-7514-b15e-f718d4d9e7da",
        "storage_key": "property/5646289643503616/019f1504-3832-7514-b15e-f718d4d9e7da.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.rebelandrosebar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14474608767359459530&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rebel--rose-neighborhood-bar",
      "poi_latitude": "32.8003005",
      "poi_longitude": "-96.8005742",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 214-647-1047",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1504-af5f-71d8-9f31-b845deb4ed5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-af5f-71d8-9f31-b845deb4ed5e",
        "storage_key": "property/5646289643503616/019f1504-af5f-71d8-9f31-b845deb4ed5e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWdLbkiyZToYRyiA38fsj4Mg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pub"
    },
    {
      "id": "ec_369b1521ef6ba68ca68f7ff8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "Bar Colette",
      "poi_type": "Restaurants",
      "poi_address": "3699 McKinney Ave #306, Dallas, TX 75204, USA",
      "poi_short_description": "Cozy West Village cocktail bar offering a curated menu of beverages and food.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1504-37c1-71bd-aa8b-a2c05eed3cb2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-37c1-71bd-aa8b-a2c05eed3cb2",
        "storage_key": "property/5646289643503616/019f1504-37c1-71bd-aa8b-a2c05eed3cb2.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.barcolette.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5337896837838835750&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bar-colette",
      "poi_latitude": "32.8079992",
      "poi_longitude": "-96.797826",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 214-377-4809",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1504-af5f-71d8-9f31-b845deb4ed5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-af5f-71d8-9f31-b845deb4ed5e",
        "storage_key": "property/5646289643503616/019f1504-af5f-71d8-9f31-b845deb4ed5e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJabkJgPOfToYRJpAQg-QEFEo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cocktail_bar"
    },
    {
      "id": "ec_fd2b4d5ad9d4fc861aa68b9e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "Joe Leo Fine Tex Mex",
      "poi_type": "Restaurants",
      "poi_address": "2722 N Fitzhugh Ave, Dallas, TX 75204, USA",
      "poi_short_description": "Cocktails & Mexican staples doled out at this quaint restaurant featuring a terrace & brunch.",
      "poi_long_description": "Cocktails & Mexican staples doled out at this quaint restaurant featuring a terrace & brunch.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1504-3555-757a-8ea1-df6cda299763.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-3555-757a-8ea1-df6cda299763",
        "storage_key": "property/5646289643503616/019f1504-3555-757a-8ea1-df6cda299763.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://joeleotexmex.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16275533490801041944&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "joe-leo-fine-tex-mex",
      "poi_latitude": "32.81477880000001",
      "poi_longitude": "-96.78587790000002",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 214-363-2699",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-aa2e-7096-a4cf-c5501d9b2e94.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-aa2e-7096-a4cf-c5501d9b2e94",
        "storage_key": "property/5646289643503616/019f1501-aa2e-7096-a4cf-c5501d9b2e94.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJGeDmUXKfToYRGGIreXpP3uE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tex_mex_restaurant"
    },
    {
      "id": "ec_963cd05b96c6ecd004ad68ba",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "Salum Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "4152 Cole Ave #103, Dallas, TX 75204, USA",
      "poi_short_description": "Seasonal New American eats from chef Abraham Salum are served amid an urbane, elegant decor.",
      "poi_long_description": "Seasonal New American eats from chef Abraham Salum are served amid an urbane, elegant decor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1504-3a81-733d-8984-cf59822fcf89.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-3a81-733d-8984-cf59822fcf89",
        "storage_key": "property/5646289643503616/019f1504-3a81-733d-8984-cf59822fcf89.webp",
        "width": 1080,
        "height": 1080
      },
      "poi_business_url": "http://salumrestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11339472120906891026&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "salum-restaurant",
      "poi_latitude": "32.8161232",
      "poi_longitude": "-96.7921513",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 214-252-9604",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-aa2e-7096-a4cf-c5501d9b2e94.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-aa2e-7096-a4cf-c5501d9b2e94",
        "storage_key": "property/5646289643503616/019f1501-aa2e-7096-a4cf-c5501d9b2e94.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJpdrv_9eeToYREr8Zm9DlXZ0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_3f181b4df86180196f38f544",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "Café OLIVIA",
      "poi_type": "Restaurants",
      "poi_address": "2200 Ross Ave Ste 100, Dallas, TX 75201, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1504-3ece-775f-9be8-75b49fb6323e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-3ece-775f-9be8-75b49fb6323e",
        "storage_key": "property/5646289643503616/019f1504-3ece-775f-9be8-75b49fb6323e.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://cafeoliviatx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6497728837133368379&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "caf-olivia",
      "poi_latitude": "32.7879686",
      "poi_longitude": "-96.796876",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 214-238-6216",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1504-af60-76cf-8f80-228d7db21989.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-af60-76cf-8f80-228d7db21989",
        "storage_key": "property/5646289643503616/019f1504-af60-76cf-8f80-228d7db21989.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJv1_38kCZToYRO3wlcPORLFo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "ec_7d59f5d247ed5c4e1dc5e9d7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "Rodeo Cold",
      "poi_type": "Restaurants",
      "poi_address": "3826 Ross Ave, Dallas, TX 75204, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1504-40bd-753f-8be6-d7ade161e8a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-40bd-753f-8be6-d7ade161e8a7",
        "storage_key": "property/5646289643503616/019f1504-40bd-753f-8be6-d7ade161e8a7.webp",
        "width": 1280,
        "height": 591
      },
      "poi_business_url": "https://www.rodeo-cold.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17408567412801492435&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rodeo-cold",
      "poi_latitude": "32.7984418",
      "poi_longitude": "-96.7851116",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 214-446-9296",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1504-af5f-71d8-9f31-b845deb4ed5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-af5f-71d8-9f31-b845deb4ed5e",
        "storage_key": "property/5646289643503616/019f1504-af5f-71d8-9f31-b845deb4ed5e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLSnr24OZToYR01V50NOnl_E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "ec_df013da5092aa42a15a2f56e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "Pecan Lodge",
      "poi_type": "Restaurants",
      "poi_address": "2702 Main St, Dallas, TX 75226, USA",
      "poi_short_description": "A variety of smoked meats, sides & desserts are served at this BBQ eatery along with beer & wine.",
      "poi_long_description": "A variety of smoked meats, sides & desserts are served at this BBQ eatery along with beer & wine.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1504-4381-740c-ad1c-5875987483eb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-4381-740c-ad1c-5875987483eb",
        "storage_key": "property/5646289643503616/019f1504-4381-740c-ad1c-5875987483eb.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.pecanlodge.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8780066691137611247&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pecan-lodge",
      "poi_latitude": "32.7836494",
      "poi_longitude": "-96.7838379",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 214-748-8900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-aa2e-7096-a4cf-c5501d9b2e94.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-aa2e-7096-a4cf-c5501d9b2e94",
        "storage_key": "property/5646289643503616/019f1501-aa2e-7096-a4cf-c5501d9b2e94.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJGXYxd92YToYR7yV_BSMQ2Xk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "ec_3f2eec5dcf4027a0a1ed45b9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "2510 McKinney Ave, Dallas, TX 75201, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-6db5-77fd-b538-ca5635b99765.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-6db5-77fd-b538-ca5635b99765",
        "storage_key": "property/5646289643503616/019f1501-6db5-77fd-b538-ca5635b99765.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/uptowndallas?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=2836622873227843908&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "32.7959367",
      "poi_longitude": "-96.8016409",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 469-518-5814",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-a9e7-776f-bac8-4370fe8d1c02.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-a9e7-776f-bac8-4370fe8d1c02",
        "storage_key": "property/5646289643503616/019f1501-a9e7-776f-bac8-4370fe8d1c02.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4Qepyi-ZToYRRFl-YHm1XSc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_0a6265c1c5fee22cbb89f790",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "Walmart Neighborhood Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "2305 N Central Expy, Dallas, TX 75204, USA",
      "poi_short_description": "Supermarket with self-service checkout and a small deli.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1504-43f5-70bd-8172-a423bc00f188.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-43f5-70bd-8172-a423bc00f188",
        "storage_key": "property/5646289643503616/019f1504-43f5-70bd-8172-a423bc00f188.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.walmart.com/store/3341-dallas-tx/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=16417328389262975456&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-neighborhood-market",
      "poi_latitude": "32.8005856",
      "poi_longitude": "-96.7941805",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 214-953-0460",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-a9e7-776f-bac8-4370fe8d1c02.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-a9e7-776f-bac8-4370fe8d1c02",
        "storage_key": "property/5646289643503616/019f1501-a9e7-776f-bac8-4370fe8d1c02.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcfPyRSqZToYR4KH08i8R1uM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_ce37184e67eaf914d0e9fce1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "2417 N Haskell Ave., Dallas, TX 75204, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1504-4514-7329-915a-c9f5b5cbcaf7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-4514-7329-915a-c9f5b5cbcaf7",
        "storage_key": "property/5646289643503616/019f1504-4514-7329-915a-c9f5b5cbcaf7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.target.com/sl/cityplace-market/875",
      "poi_directions_map_url": "https://maps.google.com/?cid=1693101220720075099&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "32.8036121",
      "poi_longitude": "-96.7913956",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 214-826-0331",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-aa2f-7039-8687-7dc16e73e6af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-aa2f-7039-8687-7dc16e73e6af",
        "storage_key": "property/5646289643503616/019f1501-aa2f-7039-8687-7dc16e73e6af.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ794dLdWYToYRW-HM_ZYafxc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_51c9e827c0ad69d53e3d4a79",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "Tom Thumb",
      "poi_type": "Shopping & Retail",
      "poi_address": "2727 Live Oak St, Dallas, TX 75204, USA",
      "poi_short_description": "Grocery chain store featuring a deli, bakery, pharmacy, a salad bar and a floral department.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1504-457d-75ab-b3e4-17741e1c2817.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-457d-75ab-b3e4-17741e1c2817",
        "storage_key": "property/5646289643503616/019f1504-457d-75ab-b3e4-17741e1c2817.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://local.tomthumb.com/tx/dallas/2727-live-oak-st.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=1821702286331902&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tom-thumb",
      "poi_latitude": "32.7890923",
      "poi_longitude": "-96.7892041",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 214-273-2115",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-a9e7-776f-bac8-4370fe8d1c02.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-a9e7-776f-bac8-4370fe8d1c02",
        "storage_key": "property/5646289643503616/019f1501-a9e7-776f-bac8-4370fe8d1c02.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_d-6RCWZToYR_s-pHdR4BgA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_1485e066bfa8be470c5839a5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "CVS",
      "poi_type": "Shopping & Retail",
      "poi_address": "4202 Ross Ave, Dallas, TX 75204, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1504-4900-730a-9fd4-663056132f57.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-4900-730a-9fd4-663056132f57",
        "storage_key": "property/5646289643503616/019f1504-4900-730a-9fd4-663056132f57.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cvs.com/store-locator/dallas-tx-pharmacies/4202-ross-ave-dallas-tx-75204/storeid=4272?WT.mc_id=LS_GOOGLE_FS_4272",
      "poi_directions_map_url": "https://maps.google.com/?cid=5522169074656399273&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "32.8001782",
      "poi_longitude": "-96.7829033",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 214-584-2480",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-aa8e-7615-b338-e4c75aa44be0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-aa8e-7615-b338-e4c75aa44be0",
        "storage_key": "property/5646289643503616/019f1501-aa8e-7615-b338-e4c75aa44be0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEc_CJtKYToYRqc-KBISvokw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_c96d361594054ac9a4bc96c6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "3418 McKinney Ave, Dallas, TX 75204, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1504-4901-735b-9655-e90a2ec78926.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-4901-735b-9655-e90a2ec78926",
        "storage_key": "property/5646289643503616/019f1504-4901-735b-9655-e90a2ec78926.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-3418+mckinney+ave-dallas-tx-75204/id=5092",
      "poi_directions_map_url": "https://maps.google.com/?cid=16987997664595125319&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "32.8050639",
      "poi_longitude": "-96.7981607",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 214-922-9283",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-aa8e-7615-b338-e4c75aa44be0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-aa8e-7615-b338-e4c75aa44be0",
        "storage_key": "property/5646289643503616/019f1501-aa8e-7615-b338-e4c75aa44be0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJubaCSNOeToYRR6Rbo959wes",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_63329c7176158eb25f29551f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "7-Eleven",
      "poi_type": "Shopping & Retail",
      "poi_address": "4024 Ross Ave @, N Haskell Ave., Dallas, TX 75204, USA",
      "poi_short_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_long_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1504-494f-73b8-b760-01b4b7464838.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-494f-73b8-b760-01b4b7464838",
        "storage_key": "property/5646289643503616/019f1504-494f-73b8-b760-01b4b7464838.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.7-eleven.com/locations/tx/dallas/4024-ross-ave-33505?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=13871726707182402865&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-eleven",
      "poi_latitude": "32.7994112",
      "poi_longitude": "-96.7835947",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 214-826-4046",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1504-af63-71ae-a2b6-ea9b603b04d7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-af63-71ae-a2b6-ea9b603b04d7",
        "storage_key": "property/5646289643503616/019f1504-af63-71ae-a2b6-ea9b603b04d7.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJfcZ7KtKYToYRMf3n0vFFgsA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_78f90331e54f6b6e1a8726a4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "West Village",
      "poi_type": "Shopping & Retail",
      "poi_address": "3699 McKinney Ave, Dallas, TX 75204, USA",
      "poi_short_description": "Laid-back retail complex with fashion boutiques, fitness studios, restaurants & a movie theater.",
      "poi_long_description": "Laid-back retail complex with fashion boutiques, fitness studios, restaurants & a movie theater.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1504-4c87-7768-9c22-5d23a1211e9a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-4c87-7768-9c22-5d23a1211e9a",
        "storage_key": "property/5646289643503616/019f1504-4c87-7768-9c22-5d23a1211e9a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.westvillagedallas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5878382062977634476&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "west-village",
      "poi_latitude": "32.8087159",
      "poi_longitude": "-96.7961747",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 469-759-2890",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-aa2f-7039-8687-7dc16e73e6af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-aa2f-7039-8687-7dc16e73e6af",
        "storage_key": "property/5646289643503616/019f1501-aa2f-7039-8687-7dc16e73e6af.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJQyZ5EtSeToYRrFDPXVc1lFE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_e01aebb56f22ed9ed26e690f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "Yellow Rose by Kendra Scott",
      "poi_type": "Shopping & Retail",
      "poi_address": "3699 McKinney Ave #105-b, Dallas, TX 75204, USA",
      "poi_short_description": "Branch of the designer's jewelry boutique known for customizable jewelry in a range of colors.",
      "poi_long_description": "Branch of the designer's jewelry boutique known for customizable jewelry in a range of colors.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1504-53e1-741f-9585-9dedbd01cdda.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-53e1-741f-9585-9dedbd01cdda",
        "storage_key": "property/5646289643503616/019f1504-53e1-741f-9585-9dedbd01cdda.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.kendrascott.com/stores/directory/store?StoreID=265166",
      "poi_directions_map_url": "https://maps.google.com/?cid=11915214509704568198&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "yellow-rose-by-kendra-scott",
      "poi_latitude": "32.80822",
      "poi_longitude": "-96.79751",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 214-528-4800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-aa2f-7039-8687-7dc16e73e6af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-aa2f-7039-8687-7dc16e73e6af",
        "storage_key": "property/5646289643503616/019f1501-aa2f-7039-8687-7dc16e73e6af.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJQyZ5EtSeToYRhl2FkXdYW6U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "jewelry_store"
    },
    {
      "id": "ec_3e306c0399e6c1f73cb8c904",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "Stanley Korshak",
      "poi_type": "Shopping & Retail",
      "poi_address": "500 Crescent Ct #100, Dallas, TX 75201, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1504-4ae2-749c-bcb1-ba7c8cfedebd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-4ae2-749c-bcb1-ba7c8cfedebd",
        "storage_key": "property/5646289643503616/019f1504-4ae2-749c-bcb1-ba7c8cfedebd.webp",
        "width": 1000,
        "height": 702
      },
      "poi_business_url": "https://stanleykorshak.mitchellstores.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16389177766214625610&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stanley-korshak",
      "poi_latitude": "32.7950842",
      "poi_longitude": "-96.8047",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 855-479-9539",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-aa2f-7039-8687-7dc16e73e6af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-aa2f-7039-8687-7dc16e73e6af",
        "storage_key": "property/5646289643503616/019f1501-aa2f-7039-8687-7dc16e73e6af.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJeXUU5OqZToYRSunzQ1gOcuM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "ec_3c179561224787df32288040",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "Booker T. Washington High School for the Performing and Visual Arts",
      "poi_type": "Education",
      "poi_address": "2501 Flora St, Dallas, TX 75201, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1504-50b9-731d-83cd-c9fb960a6b33.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-50b9-731d-83cd-c9fb960a6b33",
        "storage_key": "property/5646289643503616/019f1504-50b9-731d-83cd-c9fb960a6b33.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://btwhspva.dallasisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1486794957952124434&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "booker-t-washington-high-school-for-the-performing-and-visual-arts",
      "poi_latitude": "32.7915487",
      "poi_longitude": "-96.7967506",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 972-925-1200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-aa5b-73ea-b3ff-c0a123207d1c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-aa5b-73ea-b3ff-c0a123207d1c",
        "storage_key": "property/5646289643503616/019f1501-aa5b-73ea-b3ff-c0a123207d1c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJA1s8biaZToYREgaUCiMoohQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_b72bcbb3cd159dbefaf3fa4a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "North Dallas High School",
      "poi_type": "Education",
      "poi_address": "3120 N Haskell Ave., Dallas, TX 75204, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1504-4fa7-73ee-87bd-eda8fbd41262.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-4fa7-73ee-87bd-eda8fbd41262",
        "storage_key": "property/5646289643503616/019f1504-4fa7-73ee-87bd-eda8fbd41262.webp",
        "width": 1080,
        "height": 1114
      },
      "poi_business_url": "https://northdallas.dallasisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12784955274259717494&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-dallas-high-school",
      "poi_latitude": "32.8100678",
      "poi_longitude": "-96.7947432",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 972-925-1500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-aa5b-73ea-b3ff-c0a123207d1c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-aa5b-73ea-b3ff-c0a123207d1c",
        "storage_key": "property/5646289643503616/019f1501-aa5b-73ea-b3ff-c0a123207d1c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ22KOZNaeToYRdt2BlxVJbbE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_7b2aa093e085eae4dd78b087",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "William B. Travis Academy",
      "poi_type": "Education",
      "poi_address": "3001 McKinney Ave, Dallas, TX 75204, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.dallasisd.org/travis",
      "poi_directions_map_url": "https://maps.google.com/?cid=13121301091061828492&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "william-b-travis-academy",
      "poi_latitude": "32.8016684",
      "poi_longitude": "-96.8014422",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 972-794-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-aa5b-73ea-b3ff-c0a123207d1c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-aa5b-73ea-b3ff-c0a123207d1c",
        "storage_key": "property/5646289643503616/019f1501-aa5b-73ea-b3ff-c0a123207d1c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJGzdUCC2ZToYRjIuvm9I5GLY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_7b4478ad86a8a53d326ded6e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "Notre Dame School of Dallas",
      "poi_type": "Education",
      "poi_address": "2018 Allen St, Dallas, TX 75204, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1504-605c-7418-a1a4-831a54ff236c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-605c-7418-a1a4-831a54ff236c",
        "storage_key": "property/5646289643503616/019f1504-605c-7418-a1a4-831a54ff236c.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.notredameschool.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11276672462802843837&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "notre-dame-school-of-dallas",
      "poi_latitude": "32.7955491",
      "poi_longitude": "-96.7953061",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 214-720-3911",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-aa5b-73ea-b3ff-c0a123207d1c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-aa5b-73ea-b3ff-c0a123207d1c",
        "storage_key": "property/5646289643503616/019f1501-aa5b-73ea-b3ff-c0a123207d1c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJVWYK8SiZToYRvfjKydvJfpw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_84a1b50391038350ec601954",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "Ben Milam Elementary School",
      "poi_type": "Education",
      "poi_address": "4200 McKinney Ave, Dallas, TX 75205, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://milam.dallasisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15134352661193482230&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ben-milam-elementary-school",
      "poi_latitude": "32.8162137",
      "poi_longitude": "-96.7904557",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 972-749-5600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-aa5b-73ea-b3ff-c0a123207d1c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-aa5b-73ea-b3ff-c0a123207d1c",
        "storage_key": "property/5646289643503616/019f1501-aa5b-73ea-b3ff-c0a123207d1c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJkToQ1yefToYR9t_sY48FCNI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_5d3f50f294378452d840efc0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "Downtown Montessori at Ida B. Wells Academy",
      "poi_type": "Education",
      "poi_address": "1901 Main St, Dallas, TX 75201, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.dallasisd.org/downtownmontessori",
      "poi_directions_map_url": "https://maps.google.com/?cid=6176142781187338306&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "downtown-montessori-at-ida-b-wells-academy",
      "poi_latitude": "32.781619",
      "poi_longitude": "-96.795135",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 972-749-2500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-aa5b-73ea-b3ff-c0a123207d1c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-aa5b-73ea-b3ff-c0a123207d1c",
        "storage_key": "property/5646289643503616/019f1501-aa5b-73ea-b3ff-c0a123207d1c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJydQoXnSZToYRQrDDCiMRtlU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_1be04d1e85d33b35863e68b6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "Dallas College El Centro Campus",
      "poi_type": "Education",
      "poi_address": "801 Main St, Dallas, TX 75202, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1504-66b6-77a9-9fd9-46a01c395c53.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-66b6-77a9-9fd9-46a01c395c53",
        "storage_key": "property/5646289643503616/019f1504-66b6-77a9-9fd9-46a01c395c53.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.dallascollege.edu/locations/el-centro/?utm_source=local&utm_medium=organic&utm_campaign=gmb&utm_content=ecc",
      "poi_directions_map_url": "https://maps.google.com/?cid=16599254427695228294&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dallas-college-el-centro-campus",
      "poi_latitude": "32.77976",
      "poi_longitude": "-96.805331",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 214-860-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-aa5b-73ea-b3ff-c0a123207d1c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-aa5b-73ea-b3ff-c0a123207d1c",
        "storage_key": "property/5646289643503616/019f1501-aa5b-73ea-b3ff-c0a123207d1c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJg5V_sBeZToYRhqUak_RlXOY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_9ea72f4858f65802f3af9ae8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "Bright Horizons at Plaza of the Americas",
      "poi_type": "Education",
      "poi_address": "700 N Pearl St Ste N101, Dallas, TX 75201, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1504-5769-72c4-ad91-50b370794deb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-5769-72c4-ad91-50b370794deb",
        "storage_key": "property/5646289643503616/019f1504-5769-72c4-ad91-50b370794deb.webp",
        "width": 1152,
        "height": 768
      },
      "poi_business_url": "https://www.brighthorizons.com/daycare-centers/tx/dallas/700-north-pearl-street-75201?utm_source=google&utm_medium=organic&utm_campaign=gmb&utm_term=weblink&utm_content=centerwebsite&IMS_SOURCE_SPECIFY=google%7Corganic%7Cgmb%7Cweblink%7Ccenterwebsite",
      "poi_directions_map_url": "https://maps.google.com/?cid=185756476354838792&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bright-horizons-at-plaza-of-the-americas",
      "poi_latitude": "32.7875161",
      "poi_longitude": "-96.7962927",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 972-349-4181",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-aa5b-73ea-b3ff-c0a123207d1c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-aa5b-73ea-b3ff-c0a123207d1c",
        "storage_key": "property/5646289643503616/019f1501-aa5b-73ea-b3ff-c0a123207d1c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJeVGyTiGZToYRCMHb84fwkwI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_531ae1e42b0a67dd3b28fd28",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "Holy Trinity Catholic School",
      "poi_type": "Education",
      "poi_address": "3815 Oak Lawn Ave, Dallas, TX 75219, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1504-5756-740b-ae76-c3e3a108fee5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-5756-740b-ae76-c3e3a108fee5",
        "storage_key": "property/5646289643503616/019f1504-5756-740b-ae76-c3e3a108fee5.webp",
        "width": 1280,
        "height": 677
      },
      "poi_business_url": "http://www.htcsdallas.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9165778736861203912&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "holy-trinity-catholic-school",
      "poi_latitude": "32.814706",
      "poi_longitude": "-96.8029071",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 214-526-5113",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-aa5b-73ea-b3ff-c0a123207d1c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-aa5b-73ea-b3ff-c0a123207d1c",
        "storage_key": "property/5646289643503616/019f1501-aa5b-73ea-b3ff-c0a123207d1c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJmY834s-eToYRyM1w5DJjM38",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_7671822fc04e3309991e3b38",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "Southern Methodist University",
      "poi_type": "Education",
      "poi_address": "Dallas, TX 75205, USA",
      "poi_short_description": "Private research school known for business & law & home to the George W. Bush Presidential Center.",
      "poi_long_description": "Private research school known for business & law & home to the George W. Bush Presidential Center.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-73f0-709c-82da-42aa602417b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-73f0-709c-82da-42aa602417b1",
        "storage_key": "property/5646289643503616/019f1501-73f0-709c-82da-42aa602417b1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.smu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13862021070155502638&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "southern-methodist-university",
      "poi_latitude": "32.8412178",
      "poi_longitude": "-96.7845175",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 214-768-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-aa5b-73ea-b3ff-c0a123207d1c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-aa5b-73ea-b3ff-c0a123207d1c",
        "storage_key": "property/5646289643503616/019f1501-aa5b-73ea-b3ff-c0a123207d1c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJFU7ARwSfToYRLlSZG7jKX8A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_40e0ebc589d15d4b8a5c9cfa",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "Klyde Warren Park",
      "poi_type": "Entertainment",
      "poi_address": "2012 Woodall Rodgers Fwy, Dallas, TX 75201, USA",
      "poi_short_description": "Urban park hosting lunchtime food trucks & frequent arts, music, fitness & children's events.",
      "poi_long_description": "Urban park hosting lunchtime food trucks & frequent arts, music, fitness & children's events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-88fd-72e8-9eba-d9bdb7855f27.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-88fd-72e8-9eba-d9bdb7855f27",
        "storage_key": "property/5646289643503616/019f1501-88fd-72e8-9eba-d9bdb7855f27.webp",
        "width": 1280,
        "height": 956
      },
      "poi_business_url": "https://www.klydewarrenpark.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5785296695854485354&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "klyde-warren-park",
      "poi_latitude": "32.7893644",
      "poi_longitude": "-96.8016184",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 214-716-4500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-aa9c-7139-b791-37f953e0e48b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-aa9c-7139-b791-37f953e0e48b",
        "storage_key": "property/5646289643503616/019f1501-aa9c-7139-b791-37f953e0e48b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJZf6cwiSZToYRas-lbLGASVA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_d88573bf939f53521960a4f9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "Perot Museum of Nature and Science",
      "poi_type": "Entertainment",
      "poi_address": "2201 N Field St, Dallas, TX 75201, USA",
      "poi_short_description": "Large-scale state-of-the-art interactive & multimedia exhibits & educational programs for all ages.",
      "poi_long_description": "Large-scale state-of-the-art interactive & multimedia exhibits & educational programs for all ages.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-77e8-7436-82a4-af3a5ac75d15.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-77e8-7436-82a4-af3a5ac75d15",
        "storage_key": "property/5646289643503616/019f1501-77e8-7436-82a4-af3a5ac75d15.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.perotmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18406171203775046302&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "perot-museum-of-nature-and-science",
      "poi_latitude": "32.7869429",
      "poi_longitude": "-96.8065844",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 214-428-5555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-aa5d-71a7-b743-52eb21520bcd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-aa5d-71a7-b743-52eb21520bcd",
        "storage_key": "property/5646289643503616/019f1501-aa5d-71a7-b743-52eb21520bcd.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ5o-djyZToYRniIJlDDbb_8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_50b8c60eee65883c1c126375",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "Dallas Museum of Art",
      "poi_type": "Entertainment",
      "poi_address": "1717 N Harwood St, Dallas, TX 75201, USA",
      "poi_short_description": "Arts District anchor with an encyclopedic collection spanning ancient times to the present.",
      "poi_long_description": "Arts District anchor with an encyclopedic collection spanning ancient times to the present.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-7e8c-70ea-8296-2734661ce969.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-7e8c-70ea-8296-2734661ce969",
        "storage_key": "property/5646289643503616/019f1501-7e8c-70ea-8296-2734661ce969.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dma.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=500356134714668464&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dallas-museum-of-art",
      "poi_latitude": "32.7876959",
      "poi_longitude": "-96.8010444",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 214-922-1200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-aa5d-71a7-b743-52eb21520bcd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-aa5d-71a7-b743-52eb21520bcd",
        "storage_key": "property/5646289643503616/019f1501-aa5d-71a7-b743-52eb21520bcd.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJe8S3giSZToYRsPXa5kCf8QY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "ec_59976a40f769c69cfc026c05",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "Nasher Sculpture Center",
      "poi_type": "Entertainment",
      "poi_address": "2001 Flora St, Dallas, TX 75201, USA",
      "poi_short_description": "Education & research facility featuring rotating exhibits of contemporary sculptures & a cafe.",
      "poi_long_description": "Education & research facility featuring rotating exhibits of contemporary sculptures & a cafe.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1504-796e-747d-9f81-9c50d7408d5c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-796e-747d-9f81-9c50d7408d5c",
        "storage_key": "property/5646289643503616/019f1504-796e-747d-9f81-9c50d7408d5c.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.nashersculpturecenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4274392123628994890&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nasher-sculpture-center",
      "poi_latitude": "32.7881824",
      "poi_longitude": "-96.8001567",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 214-242-5100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-aa5d-71a7-b743-52eb21520bcd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-aa5d-71a7-b743-52eb21520bcd",
        "storage_key": "property/5646289643503616/019f1501-aa5d-71a7-b743-52eb21520bcd.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJnTv3iySZToYRSkGiX_2wUTs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_a6bf651533eb71d4126e5f93",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "Winspear Opera House",
      "poi_type": "Entertainment",
      "poi_address": "2403 Flora St, Dallas, TX 75201, USA",
      "poi_short_description": "Lavish horseshoe theater with famed sleek architecture staging opera, Broadway & more since 2009.",
      "poi_long_description": "Lavish horseshoe theater with famed sleek architecture staging opera, Broadway & more since 2009.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1504-6fa9-73d8-9b59-74c6cb3aa0cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-6fa9-73d8-9b59-74c6cb3aa0cc",
        "storage_key": "property/5646289643503616/019f1504-6fa9-73d8-9b59-74c6cb3aa0cc.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.attpac.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6139129715722408193&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "winspear-opera-house",
      "poi_latitude": "32.79110230000001",
      "poi_longitude": "-96.7974707",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 214-880-0202",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-aa8e-7615-b338-e4c75aa44be0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-aa8e-7615-b338-e4c75aa44be0",
        "storage_key": "property/5646289643503616/019f1501-aa8e-7615-b338-e4c75aa44be0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7W-zeCaZToYRAdGtL_ORMlU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "opera_house"
    },
    {
      "id": "ec_4e4ad65cec2a55b135577708",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "Dallas Symphony Orchestra",
      "poi_type": "Entertainment",
      "poi_address": "2301 Flora St, Dallas, TX 75201, USA",
      "poi_short_description": "I. M. Pei-designed home to the Dallas Symphony is  also host to visiting orchestras & musical acts.",
      "poi_long_description": "I. M. Pei-designed home to the Dallas Symphony is  also host to visiting orchestras & musical acts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1504-724a-715d-963d-ef8d0531dc8e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-724a-715d-963d-ef8d0531dc8e",
        "storage_key": "property/5646289643503616/019f1504-724a-715d-963d-ef8d0531dc8e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.dallassymphony.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8364654381389290641&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dallas-symphony-orchestra",
      "poi_latitude": "32.7898987",
      "poi_longitude": "-96.7985956",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 214-849-4376",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-aa8e-7615-b338-e4c75aa44be0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-aa8e-7615-b338-e4c75aa44be0",
        "storage_key": "property/5646289643503616/019f1501-aa8e-7615-b338-e4c75aa44be0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkX8jRySZToYRkZyfj9c4FXQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_97f0eae7d5a409efed890bdf",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "American Airlines Center",
      "poi_type": "Entertainment",
      "poi_address": "2500 Victory Ave, Dallas, TX 75219, USA",
      "poi_short_description": "Modern venue that hosts concerts by big-name acts and serves as the home ground of the Dallas Mavericks basketball team and Dallas Stars hockey team.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-7400-746d-bdc1-83f938e6f292.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-7400-746d-bdc1-83f938e6f292",
        "storage_key": "property/5646289643503616/019f1501-7400-746d-bdc1-83f938e6f292.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.americanairlinescenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2405235901812051875&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "american-airlines-center",
      "poi_latitude": "32.7903908",
      "poi_longitude": "-96.8102547",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 214-665-4299",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-aa8e-7615-b338-e4c75aa44be0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-aa8e-7615-b338-e4c75aa44be0",
        "storage_key": "property/5646289643503616/019f1501-aa8e-7615-b338-e4c75aa44be0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJr-XOXC-ZToYRow-GKE8dYSE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "ec_4cf53eca6e2ebc00f624dd86",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "House of Blues Dallas",
      "poi_type": "Entertainment",
      "poi_address": "2200 N Lamar St, Dallas, TX 75202, USA",
      "poi_short_description": "Rock- & blues-themed restaurant & bar serving Southern-inspired dishes, plus live music.",
      "poi_long_description": "Rock- & blues-themed restaurant & bar serving Southern-inspired dishes, plus live music.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1504-69b8-77fd-b187-62321f080edd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-69b8-77fd-b187-62321f080edd",
        "storage_key": "property/5646289643503616/019f1504-69b8-77fd-b187-62321f080edd.webp",
        "width": 640,
        "height": 360
      },
      "poi_business_url": "https://dallas.houseofblues.com/?utm_source=GMBlisting&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=11921814683536102827&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "house-of-blues-dallas",
      "poi_latitude": "32.7850629",
      "poi_longitude": "-96.8081932",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 214-978-2583",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-aa8e-7615-b338-e4c75aa44be0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-aa8e-7615-b338-e4c75aa44be0",
        "storage_key": "property/5646289643503616/019f1501-aa8e-7615-b338-e4c75aa44be0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzQfNJjyZToYRq5U0SkrLcqU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "ec_b942f3f7afc41214708479f1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "The Bomb Factory",
      "poi_type": "Entertainment",
      "poi_address": "2713 Canton St, Dallas, TX 75226, USA",
      "poi_short_description": "Roomy live music & event venue with a capacity of 4,300, offering touring national & local acts.",
      "poi_long_description": "Roomy live music & event venue with a capacity of 4,300, offering touring national & local acts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1504-757c-77cf-b101-ca9153fb3629.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-757c-77cf-b101-ca9153fb3629",
        "storage_key": "property/5646289643503616/019f1504-757c-77cf-b101-ca9153fb3629.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://thebombfactory.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2374544678486734901&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-bomb-factory",
      "poi_latitude": "32.782355",
      "poi_longitude": "-96.7838027",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 214-749-5757",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-aa8e-7615-b338-e4c75aa44be0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-aa8e-7615-b338-e4c75aa44be0",
        "storage_key": "property/5646289643503616/019f1501-aa8e-7615-b338-e4c75aa44be0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkc_KheeYToYRNfh-4M0T9CA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "ec_fb924cee7af310c4ba6ea250",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "The Dallas World Aquarium",
      "poi_type": "Entertainment",
      "poi_address": "1801 N Griffin St, Dallas, TX 75202, USA",
      "poi_short_description": "Replica habitats containing exotic birds, mammals & fish are open for public tours & private events.",
      "poi_long_description": "Replica habitats containing exotic birds, mammals & fish are open for public tours & private events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-7785-753e-882a-8012246ac95c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-7785-753e-882a-8012246ac95c",
        "storage_key": "property/5646289643503616/019f1501-7785-753e-882a-8012246ac95c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.dwazoo.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1754665305414928610&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-dallas-world-aquarium",
      "poi_latitude": "32.7834737",
      "poi_longitude": "-96.805358",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 214-720-2224",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-aa8e-7615-b338-e4c75aa44be0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-aa8e-7615-b338-e4c75aa44be0",
        "storage_key": "property/5646289643503616/019f1501-aa8e-7615-b338-e4c75aa44be0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_8GjDj2ZToYR4oj1dMzSWRg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "ec_62de19023069c2fb81978bf5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "Baylor University Medical Center, part of Baylor Scott & White Health",
      "poi_type": "Health and Wellness",
      "poi_address": "3500 Gaston Ave, Dallas, TX 75246, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1504-6f8b-7549-bf66-3c9d75c5d40a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-6f8b-7549-bf66-3c9d75c5d40a",
        "storage_key": "property/5646289643503616/019f1504-6f8b-7549-bf66-3c9d75c5d40a.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.bswhealth.com/locations/hospital/dallas?utm_content=main-website&utm_source=pg-google&utm_medium=organic&utm_campaign=29985-9717571",
      "poi_directions_map_url": "https://maps.google.com/?cid=1052454823151725673&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "baylor-university-medical-center-part-of-baylor-scott--white-health",
      "poi_latitude": "32.7904132",
      "poi_longitude": "-96.7799639",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 214-820-0111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-aa5b-73ea-b3ff-bd161122672d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-aa5b-73ea-b3ff-bd161122672d",
        "storage_key": "property/5646289643503616/019f1501-aa5b-73ea-b3ff-bd161122672d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJTZxCv8SYToYRaewa5BUSmw4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_57ffd549c42e768cc20b80ed",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "Allcare Family And Urgent Care Clinics",
      "poi_type": "Health and Wellness",
      "poi_address": "3825 Ross Ave #150, Dallas, TX 75204, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1504-7a26-70cf-b9dd-539a6c61cfff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-7a26-70cf-b9dd-539a6c61cfff",
        "storage_key": "property/5646289643503616/019f1504-7a26-70cf-b9dd-539a6c61cfff.webp",
        "width": 1280,
        "height": 1010
      },
      "poi_business_url": "https://allcareclinicsdallas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7293617668290539676&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "allcare-family-and-urgent-care-clinics",
      "poi_latitude": "32.7989035",
      "poi_longitude": "-96.7852887",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 214-515-9646",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-aa8e-7615-b338-e4c75aa44be0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-aa8e-7615-b338-e4c75aa44be0",
        "storage_key": "property/5646289643503616/019f1501-aa8e-7615-b338-e4c75aa44be0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJE8UlMtKYToYRnHD4RaAiOGU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_5beb3375c3afd96d3557dfa7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "4202 Ross Ave, Dallas, TX 75204, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1504-7323-779e-8ff0-b3c1ab38c855.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-7323-779e-8ff0-b3c1ab38c855",
        "storage_key": "property/5646289643503616/019f1504-7323-779e-8ff0-b3c1ab38c855.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/dallas-tx-pharmacies/4202-ross-ave-dallas-tx-75204/storeid=4272?WT.mc_id=LS_GOOGLE_RX_4272",
      "poi_directions_map_url": "https://maps.google.com/?cid=9794562207688108008&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "32.8001782",
      "poi_longitude": "-96.7829033",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 214-584-2480",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1504-af73-766e-af3d-b7b495e84f51.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-af73-766e-af3d-b7b495e84f51",
        "storage_key": "property/5646289643503616/019f1504-af73-766e-af3d-b7b495e84f51.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWUFxItKYToYR6Ce3H29G7Yc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_ebd3cc9c6c6d366137799a82",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "3418 McKinney Ave, Dallas, TX 75204, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1504-4901-735b-9655-e90a2ec78926.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-4901-735b-9655-e90a2ec78926",
        "storage_key": "property/5646289643503616/019f1504-4901-735b-9655-e90a2ec78926.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-3418+mckinney+ave-dallas-tx-75204/id=5092",
      "poi_directions_map_url": "https://maps.google.com/?cid=16987997664595125319&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "32.8050639",
      "poi_longitude": "-96.7981607",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 214-922-9283",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-aa8e-7615-b338-e4c75aa44be0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-aa8e-7615-b338-e4c75aa44be0",
        "storage_key": "property/5646289643503616/019f1501-aa8e-7615-b338-e4c75aa44be0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJubaCSNOeToYRR6Rbo959wes",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_fdc1bc901cadf56e19644681",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2690 N Haskell Ave., Dallas, TX 75204, USA",
      "poi_short_description": "Chain gym featuring a pool, basketball court, and state-of-the-art equipment, plus personal training.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-789f-741e-9376-79acd3031eb5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-789f-741e-9376-79acd3031eb5",
        "storage_key": "property/5646289643503616/019f1501-789f-741e-9376-79acd3031eb5.webp",
        "width": 1080,
        "height": 1080
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=697&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=7595466955778861992&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "32.8067293",
      "poi_longitude": "-96.7906453",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 214-530-0005",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-aa8e-7615-b338-e4c75aa44be0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-aa8e-7615-b338-e4c75aa44be0",
        "storage_key": "property/5646289643503616/019f1501-aa8e-7615-b338-e4c75aa44be0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ88oelyqfToYRqKtqKvSEaGk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_06f523db7277bb92a16f44fc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "CorePower Yoga - West Village-Dallas",
      "poi_type": "Health and Wellness",
      "poi_address": "2970 Cityplace W Blvd #130, Dallas, TX 75204, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1504-800e-7469-97be-cad236885928.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-800e-7469-97be-cad236885928",
        "storage_key": "property/5646289643503616/019f1504-800e-7469-97be-cad236885928.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.corepoweryoga.com/yoga-studios/tx/dallas/west-village-dallas",
      "poi_directions_map_url": "https://maps.google.com/?cid=145319036750059940&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "corepower-yoga---west-village-dallas",
      "poi_latitude": "32.8071384",
      "poi_longitude": "-96.7954372",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 833-448-2561",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-aa5b-73ea-b3ff-c0a123207d1c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-aa5b-73ea-b3ff-c0a123207d1c",
        "storage_key": "property/5646289643503616/019f1501-aa5b-73ea-b3ff-c0a123207d1c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJDxCdlTmfToYRpNmW3ORGBAI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "ec_704ca4631bf81a17b1acb614",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "CycleBar",
      "poi_type": "Health and Wellness",
      "poi_address": "2020 Cedar Springs Rd Suite 180, Dallas, TX 75201, USA",
      "poi_short_description": "Energetic classes for all fitness levels at this chain gym featuring an indoor cycling studio.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1504-79bd-726a-be42-860d33e84564.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-79bd-726a-be42-860d33e84564",
        "storage_key": "property/5646289643503616/019f1504-79bd-726a-be42-860d33e84564.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "http://cyclebar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8344305261918767170&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cyclebar",
      "poi_latitude": "32.7909329",
      "poi_longitude": "-96.8047741",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 214-733-9473",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-aa8e-7615-b338-e4c75aa44be0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-aa8e-7615-b338-e4c75aa44be0",
        "storage_key": "property/5646289643503616/019f1501-aa8e-7615-b338-e4c75aa44be0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXYOk7TqZToYRQkgX-mztzHM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_0209521fae302be63962ab02",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "Pure Barre",
      "poi_type": "Health and Wellness",
      "poi_address": "3700 McKinney Ave Suite 130, Dallas, TX 75204, USA",
      "poi_short_description": "Studio for low-impact, high-intensity workouts incorporating yoga and ballet moves.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1504-7903-7028-a1da-01d33e5cd346.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-7903-7028-a1da-01d33e5cd346",
        "storage_key": "property/5646289643503616/019f1504-7903-7028-a1da-01d33e5cd346.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.purebarre.com/location/dallas-uptown-tx",
      "poi_directions_map_url": "https://maps.google.com/?cid=4768861891305425202&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pure-barre",
      "poi_latitude": "32.8083923",
      "poi_longitude": "-96.7957854",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 214-521-6600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-aa8e-7615-b338-e4c75aa44be0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-aa8e-7615-b338-e4c75aa44be0",
        "storage_key": "property/5646289643503616/019f1501-aa8e-7615-b338-e4c75aa44be0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhxUNZdSeToYRMkkopp9mLkI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "ec_592a7fb40e9dbe41665317b2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "Orangetheory Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "4447 N Central Expy #100, Dallas, TX 75205, USA",
      "poi_short_description": "Group cardio and strength-training, one-hour fitness classes led by certified coaches and trainers.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1504-8a25-77d5-b11e-b0ad435ad79d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-8a25-77d5-b11e-b0ad435ad79d",
        "storage_key": "property/5646289643503616/019f1504-8a25-77d5-b11e-b0ad435ad79d.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/dallas-texas-1029?utm_medium=seo&utm_source=gg&utm_term=corporate&utm_campaign=soci",
      "poi_directions_map_url": "https://maps.google.com/?cid=16424445845804514700&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orangetheory-fitness",
      "poi_latitude": "32.8204187",
      "poi_longitude": "-96.7876123",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 972-474-0382",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-aa8e-7615-b338-e4c75aa44be0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-aa8e-7615-b338-e4c75aa44be0",
        "storage_key": "property/5646289643503616/019f1501-aa8e-7615-b338-e4c75aa44be0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnYbslyafToYRjH3R73la7-M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_92508f6ce131bc4ac5002dbf",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "Parkland Health",
      "poi_type": "Health and Wellness",
      "poi_address": "5200 Harry Hines Blvd, Dallas, TX 75235, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-885b-70ac-ac99-2f612ab449c6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-885b-70ac-ac99-2f612ab449c6",
        "storage_key": "property/5646289643503616/019f1501-885b-70ac-ac99-2f612ab449c6.webp",
        "width": 940,
        "height": 788
      },
      "poi_business_url": "http://www.parklandhealth.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8882318995387276974&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "parkland-health",
      "poi_latitude": "32.8135637",
      "poi_longitude": "-96.8348",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 214-590-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-aa5b-73ea-b3ff-bd161122672d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-aa5b-73ea-b3ff-bd161122672d",
        "storage_key": "property/5646289643503616/019f1501-aa5b-73ea-b3ff-bd161122672d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJO6FKVW6dToYRrl7D1RBWRHs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "ec_0b5746cb7810781a0ce0d859",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "Klyde Warren Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2012 Woodall Rodgers Fwy, Dallas, TX 75201, USA",
      "poi_short_description": "Urban park hosting lunchtime food trucks & frequent arts, music, fitness & children's events.",
      "poi_long_description": "Urban park hosting lunchtime food trucks & frequent arts, music, fitness & children's events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-88fd-72e8-9eba-d9bdb7855f27.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-88fd-72e8-9eba-d9bdb7855f27",
        "storage_key": "property/5646289643503616/019f1501-88fd-72e8-9eba-d9bdb7855f27.webp",
        "width": 1280,
        "height": 956
      },
      "poi_business_url": "https://www.klydewarrenpark.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5785296695854485354&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "klyde-warren-park",
      "poi_latitude": "32.7893644",
      "poi_longitude": "-96.8016184",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 214-716-4500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-aa9c-7139-b791-37f953e0e48b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-aa9c-7139-b791-37f953e0e48b",
        "storage_key": "property/5646289643503616/019f1501-aa9c-7139-b791-37f953e0e48b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJZf6cwiSZToYRas-lbLGASVA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_3dde0993ecd77b2aef0ba751",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "Main Street Garden Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1902 Main St, Dallas, TX 75201, USA",
      "poi_short_description": "Public great lawn with WiFi, a toddler play area, a dog run, fountains, public art & a cafe.",
      "poi_long_description": "Public great lawn with WiFi, a toddler play area, a dog run, fountains, public art & a cafe.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1504-8443-723a-846b-69ba29f4fbf5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-8443-723a-846b-69ba29f4fbf5",
        "storage_key": "property/5646289643503616/019f1504-8443-723a-846b-69ba29f4fbf5.webp",
        "width": 701,
        "height": 438
      },
      "poi_business_url": "http://mainstreetgarden.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=873616607177198723&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "main-street-garden-park",
      "poi_latitude": "32.7811695",
      "poi_longitude": "-96.7948469",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 214-744-1270",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-aa9c-7139-b791-37f953e0e48b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-aa9c-7139-b791-37f953e0e48b",
        "storage_key": "property/5646289643503616/019f1501-aa9c-7139-b791-37f953e0e48b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJRfzcnR-ZToYRg8yt9Ky1Hww",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_2c240531f1c3f2f73cc7b711",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "Reverchon Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3505 Maple Ave, Dallas, TX 75219, USA",
      "poi_short_description": "46-acre park along Turtle Creek & the Katy Trail sports a playground & recreation facilities.",
      "poi_long_description": "46-acre park along Turtle Creek & the Katy Trail sports a playground & recreation facilities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1504-8952-770d-b293-e4d90c3cc5df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-8952-770d-b293-e4d90c3cc5df",
        "storage_key": "property/5646289643503616/019f1504-8952-770d-b293-e4d90c3cc5df.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.dallasparks.org/facilities/facility/details/Reverchon-Park-635",
      "poi_directions_map_url": "https://maps.google.com/?cid=13222699046125383358&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "reverchon-park",
      "poi_latitude": "32.8004217",
      "poi_longitude": "-96.8126311",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 214-670-7720",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-aa9c-7139-b791-37f953e0e48b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-aa9c-7139-b791-37f953e0e48b",
        "storage_key": "property/5646289643503616/019f1501-aa9c-7139-b791-37f953e0e48b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJi5pg_DSZToYRvi4zwLl2gLc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_e943415ac72c9fce9523c391",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "Katy Trail Access",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4825 Cole Ave, Dallas, TX 75205, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1504-8a95-727e-afc4-adb1ca527bc1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-8a95-727e-afc4-adb1ca527bc1",
        "storage_key": "property/5646289643503616/019f1504-8a95-727e-afc4-adb1ca527bc1.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://katytraildallas.org/trail-info/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11429482193493253539&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "katy-trail-access",
      "poi_latitude": "32.8274627",
      "poi_longitude": "-96.7870456",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-aa8e-7615-b338-e4c75aa44be0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-aa8e-7615-b338-e4c75aa44be0",
        "storage_key": "property/5646289643503616/019f1501-aa8e-7615-b338-e4c75aa44be0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMQXizgKfToYRo13RvX-tnZ4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "ec_24448ea07a97162a47f9f9e3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "Exall Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1355 Adair St, Dallas, TX 75204, USA",
      "poi_short_description": "Outdoor playground & sports fields, walking trails, picnic grills & an indoor recreation center.",
      "poi_long_description": "Outdoor playground & sports fields, walking trails, picnic grills & an indoor recreation center.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1504-8641-71a8-a087-68ca76ae14af.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-8641-71a8-a087-68ca76ae14af",
        "storage_key": "property/5646289643503616/019f1504-8641-71a8-a087-68ca76ae14af.webp",
        "width": 400,
        "height": 259
      },
      "poi_business_url": "http://www.dallasparks.org/Facilities/Facility/Details/Exall-Park-478",
      "poi_directions_map_url": "https://maps.google.com/?cid=12584663239219578697&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "exall-park",
      "poi_latitude": "32.7932147",
      "poi_longitude": "-96.7850637",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 214-670-4100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-aa9c-7139-b791-37f953e0e48b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-aa9c-7139-b791-37f953e0e48b",
        "storage_key": "property/5646289643503616/019f1501-aa9c-7139-b791-37f953e0e48b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJd9cvbtqYToYRSYeZJ4q0pa4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_c25649c89dd3d4ed5271ff14",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "Trinity River Audubon Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6500 S Great Trinity Forest Way, Dallas, TX 75217, USA",
      "poi_short_description": "Nature preserve with hiking & biking trails, guided walks & many bird-watching lookouts.",
      "poi_long_description": "Nature preserve with hiking & biking trails, guided walks & many bird-watching lookouts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1504-86fe-7416-a145-9fe27fbb6490.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-86fe-7416-a145-9fe27fbb6490",
        "storage_key": "property/5646289643503616/019f1504-86fe-7416-a145-9fe27fbb6490.webp",
        "width": 647,
        "height": 431
      },
      "poi_business_url": "http://trinityriver.audubon.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11755642269813912818&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trinity-river-audubon-center",
      "poi_latitude": "32.7036486",
      "poi_longitude": "-96.70531",
      "poi_miles_from_property": "12.0 mi",
      "poi_walking_minutes": "4 hours 28 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 214-309-5801",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-aa9c-7139-b791-37f953e0e48b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-aa9c-7139-b791-37f953e0e48b",
        "storage_key": "property/5646289643503616/019f1501-aa9c-7139-b791-37f953e0e48b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJZUzHmSm9ToYR8jTTPlxuJKM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "ec_8807340900445a71d4437872",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "The Dallas Arboretum and Botanical Garden",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8525 Garland Rd, Dallas, TX 75218, USA",
      "poi_short_description": "66-acre botanical garden set on White Rock Lake with frequent concerts, special exhibits & classes.",
      "poi_long_description": "66-acre botanical garden set on White Rock Lake with frequent concerts, special exhibits & classes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-8964-72a5-b5dc-b7c14c3c3cb1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-8964-72a5-b5dc-b7c14c3c3cb1",
        "storage_key": "property/5646289643503616/019f1501-8964-72a5-b5dc-b7c14c3c3cb1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dallasarboretum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7499498569549444674&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-dallas-arboretum-and-botanical-garden",
      "poi_latitude": "32.8236184",
      "poi_longitude": "-96.7166236",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 214-515-6615",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-aa8e-7615-b338-e4c75aa44be0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-aa8e-7615-b338-e4c75aa44be0",
        "storage_key": "property/5646289643503616/019f1501-aa8e-7615-b338-e4c75aa44be0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRxtoZJqhToYRQnaLBzeSE2g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "ec_3dba170538b17309a3880597",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "St Paul Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Dallas, TX 75201, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1504-8fa0-755d-a3c8-f2de58c87908.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-8fa0-755d-a3c8-f2de58c87908",
        "storage_key": "property/5646289643503616/019f1504-8fa0-755d-a3c8-f2de58c87908.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=6027887250791965099&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-paul-station",
      "poi_latitude": "32.784328",
      "poi_longitude": "-96.7969341",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-aa8e-7615-b338-e4c75aa44be0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-aa8e-7615-b338-e4c75aa44be0",
        "storage_key": "property/5646289643503616/019f1501-aa8e-7615-b338-e4c75aa44be0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhUUuhSGZToYRq6GPeYRbp1M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "ec_9c379c22bd9032f64b205c74",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "Pearl/Arts District Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Dallas, TX 75201, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-9513-767c-9b10-3415dc538400.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-9513-767c-9b10-3415dc538400",
        "storage_key": "property/5646289643503616/019f1501-9513-767c-9b10-3415dc538400.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.dart.org/riding/stations/pearlartsdistrictstation.asp",
      "poi_directions_map_url": "https://maps.google.com/?cid=9991684355496389272&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pearlarts-district-station",
      "poi_latitude": "32.7866094",
      "poi_longitude": "-96.7943561",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-aa8e-7615-b338-e4c75aa44be0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-aa8e-7615-b338-e4c75aa44be0",
        "storage_key": "property/5646289643503616/019f1501-aa8e-7615-b338-e4c75aa44be0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJR58A6CCZToYRmKowrfuXqYo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "ec_542ee6459fc9f134546f215a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "West End Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Dallas, TX 75202, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1504-9a42-7404-8232-19c55a1bfd40.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-9a42-7404-8232-19c55a1bfd40",
        "storage_key": "property/5646289643503616/019f1504-9a42-7404-8232-19c55a1bfd40.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dart.org/riding/stations/westendstation.asp",
      "poi_directions_map_url": "https://maps.google.com/?cid=9854338579002565927&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "west-end-station",
      "poi_latitude": "32.7808701",
      "poi_longitude": "-96.8054252",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-aa8e-7615-b338-e4c75aa44be0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-aa8e-7615-b338-e4c75aa44be0",
        "storage_key": "property/5646289643503616/019f1501-aa8e-7615-b338-e4c75aa44be0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwcBGzReZToYRJyXgIbqkwYg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_2abf51d8287711b698a9c5d5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "Akard",
      "poi_type": "Transportation & Transit",
      "poi_address": "Dallas, TX 75202, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-91f8-72ff-b159-bb0e484f14ff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-91f8-72ff-b159-bb0e484f14ff",
        "storage_key": "property/5646289643503616/019f1501-91f8-72ff-b159-bb0e484f14ff.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dart.org/riding/stations/akardstation.asp",
      "poi_directions_map_url": "https://maps.google.com/?cid=7273346411654948223&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "akard",
      "poi_latitude": "32.7819",
      "poi_longitude": "-96.8005637",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-aa8e-7615-b338-e4c75aa44be0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-aa8e-7615-b338-e4c75aa44be0",
        "storage_key": "property/5646289643503616/019f1501-aa8e-7615-b338-e4c75aa44be0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJz8KaeBiZToYRfyUOiwYe8GQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "ec_5083493dd25f863cb55695d5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "EBJ Union",
      "poi_type": "Transportation & Transit",
      "poi_address": "400 S Houston St, Dallas, TX 75202, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1504-906f-764b-a5df-1a6213a6bb96.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-906f-764b-a5df-1a6213a6bb96",
        "storage_key": "property/5646289643503616/019f1504-906f-764b-a5df-1a6213a6bb96.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=9329218136074997600&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ebj-union",
      "poi_latitude": "32.7760981",
      "poi_longitude": "-96.8072496",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-aa8e-7615-b338-e4c75aa44be0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-aa8e-7615-b338-e4c75aa44be0",
        "storage_key": "property/5646289643503616/019f1501-aa8e-7615-b338-e4c75aa44be0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJc0CwsRaZToYRYM_haHcKeIE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_station"
    },
    {
      "id": "ec_1cff020756f42ae6b21da087",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "Cityplace/Uptown",
      "poi_type": "Transportation & Transit",
      "poi_address": "Dallas, TX 75204, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1504-99bb-70f9-aefd-c55323a65932.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-99bb-70f9-aefd-c55323a65932",
        "storage_key": "property/5646289643503616/019f1504-99bb-70f9-aefd-c55323a65932.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dart.org/riding/stations/cityplaceuptownstation.asp",
      "poi_directions_map_url": "https://maps.google.com/?cid=11104351418223574477&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cityplaceuptown",
      "poi_latitude": "32.8055104",
      "poi_longitude": "-96.7938806",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-aa8e-7615-b338-e4c75aa44be0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-aa8e-7615-b338-e4c75aa44be0",
        "storage_key": "property/5646289643503616/019f1501-aa8e-7615-b338-e4c75aa44be0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT38_W9WeToYRzT1SEMiUGpo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "ec_7190d09c23b07e51575a1501",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "Ross & St Paul",
      "poi_type": "Transportation & Transit",
      "poi_address": "Dallas, TX 75201, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1504-92c0-76ee-930f-7b1852e222a9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-92c0-76ee-930f-7b1852e222a9",
        "storage_key": "property/5646289643503616/019f1504-92c0-76ee-930f-7b1852e222a9.webp",
        "width": 947,
        "height": 1269
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=3387852329136154717&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ross--st-paul",
      "poi_latitude": "32.7862131",
      "poi_longitude": "-96.8004254",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-aa8e-7615-b338-e4c75aa44be0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-aa8e-7615-b338-e4c75aa44be0",
        "storage_key": "property/5646289643503616/019f1501-aa8e-7615-b338-e4c75aa44be0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVSMbdSOZToYRXeijZb4RBC8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_14ccaba9e9b53bce0f16c5b6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "McKinney Avenue Trolley Uptown Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "2700 Cityplace W Blvd, Dallas, TX 75204, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1504-9fae-7187-98cf-6074774cfeb7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-9fae-7187-98cf-6074774cfeb7",
        "storage_key": "property/5646289643503616/019f1504-9fae-7187-98cf-6074774cfeb7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mata.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12952496169946490726&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mckinney-avenue-trolley-uptown-station",
      "poi_latitude": "32.8056125",
      "poi_longitude": "-96.794107",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-aa8e-7615-b338-e4c75aa44be0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-aa8e-7615-b338-e4c75aa44be0",
        "storage_key": "property/5646289643503616/019f1501-aa8e-7615-b338-e4c75aa44be0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJH80tOdWeToYRZqdELKSCwLM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_8fa62a6b7333e73d761d5a18",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "Victory",
      "poi_type": "Transportation & Transit",
      "poi_address": "Dallas, TX 75207, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1504-a594-7267-bd28-32722abb5266.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-a594-7267-bd28-32722abb5266",
        "storage_key": "property/5646289643503616/019f1504-a594-7267-bd28-32722abb5266.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dart.org/riding/stations/victorystation.asp",
      "poi_directions_map_url": "https://maps.google.com/?cid=16328810137808152136&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "victory",
      "poi_latitude": "32.7896926",
      "poi_longitude": "-96.8124819",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 214-979-1111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-aa8e-7615-b338-e4c75aa44be0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-aa8e-7615-b338-e4c75aa44be0",
        "storage_key": "property/5646289643503616/019f1501-aa8e-7615-b338-e4c75aa44be0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJz2yaYDiZToYRSCbafE6Wm-I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_stop"
    },
    {
      "id": "ec_4fc1928278792e484597e751",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "Dallas Love Field",
      "poi_type": "Transportation & Transit",
      "poi_address": "8008 Herb Kelleher Way, Dallas, TX 75235, USA",
      "poi_short_description": "Airport featuring a variety of permanent & rotating artwork, including sculptures & paintings.",
      "poi_long_description": "Airport featuring a variety of permanent & rotating artwork, including sculptures & paintings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-8e77-7435-910c-25694a1e5d61.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-8e77-7435-910c-25694a1e5d61",
        "storage_key": "property/5646289643503616/019f1501-8e77-7435-910c-25694a1e5d61.webp",
        "width": 1280,
        "height": 427
      },
      "poi_business_url": "https://www.dallas-lovefield.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16894157064492491654&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dallas-love-field",
      "poi_latitude": "32.8438345",
      "poi_longitude": "-96.8484951",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 214-670-5683",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-a9e4-75ca-b68c-6dcdf2b437c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-a9e4-75ca-b68c-6dcdf2b437c2",
        "storage_key": "property/5646289643503616/019f1501-a9e4-75ca-b68c-6dcdf2b437c2.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0RIjmDScToYRhiO7UFcadOo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "ec_797afb28751972d198e5ef47",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "Comerica Bank",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1717 Main St, Dallas, TX 75201, USA",
      "poi_short_description": "Chain bank with a drive-thru and ATM offering appointment-only services.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1504-a3ea-702d-9e90-12b10dd3097b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-a3ea-702d-9e90-12b10dd3097b",
        "storage_key": "property/5646289643503616/019f1504-a3ea-702d-9e90-12b10dd3097b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://locations.comerica.com/location/comerica-bank-tower",
      "poi_directions_map_url": "https://maps.google.com/?cid=2399412933434620196&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "comerica-bank",
      "poi_latitude": "32.7816569",
      "poi_longitude": "-96.7968379",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 214-462-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1504-af62-70bb-a01b-5c6611de347b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-af62-70bb-a01b-5c6611de347b",
        "storage_key": "property/5646289643503616/019f1504-af62-70bb-a01b-5c6611de347b.webp",
        "width": 192,
        "height": 139
      },
      "poi_google_place_id": "ChIJ0d3gQh-ZToYRJDnZrlltTCE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bank"
    },
    {
      "id": "ec_4ad3983fe4e12380e8e53ba3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "Dallas Arts Tower",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2200 Ross Ave, Dallas, TX 75201, USA",
      "poi_short_description": "Business center featuring a sky lobby that offers scenic views.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1504-a6b7-74f9-a250-053614eaf3cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-a6b7-74f9-a250-053614eaf3cf",
        "storage_key": "property/5646289643503616/019f1504-a6b7-74f9-a250-053614eaf3cf.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://dallasartstower.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14147504591255252426&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dallas-arts-tower",
      "poi_latitude": "32.7879943",
      "poi_longitude": "-96.7966835",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 214-777-5300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-aa8e-7615-b338-e4c75aa44be0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-aa8e-7615-b338-e4c75aa44be0",
        "storage_key": "property/5646289643503616/019f1501-aa8e-7615-b338-e4c75aa44be0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhw6PsSaZToYRyi36E3gIVsQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "business_center"
    },
    {
      "id": "ec_745ad15480c24b5252548de4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "Dallas City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1500 Marilla St, Dallas, TX 75201, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-9a42-771f-9ac3-92b68c7110b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-9a42-771f-9ac3-92b68c7110b5",
        "storage_key": "property/5646289643503616/019f1501-9a42-771f-9ac3-92b68c7110b5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://dallascityhall.com/Pages/default.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=4029763817868914858&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dallas-city-hall",
      "poi_latitude": "32.7764068",
      "poi_longitude": "-96.7970783",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 214-670-3111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-aa60-700e-b8e6-9100206477af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-aa60-700e-b8e6-9100206477af",
        "storage_key": "property/5646289643503616/019f1501-aa60-700e-b8e6-9100206477af.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0b-mARyZToYRqnDMfNeY7Dc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "ec_24ab21bb199bf049c6aa0efd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "Dallas County Records Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "500 Elm St Suite 2100, Dallas, TX 75202, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1504-a1f9-756b-b53d-7a45cf37bb4c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-a1f9-756b-b53d-7a45cf37bb4c",
        "storage_key": "property/5646289643503616/019f1504-a1f9-756b-b53d-7a45cf37bb4c.webp",
        "width": 1200,
        "height": 700
      },
      "poi_business_url": "https://www.dallascounty.org/government/county-clerk/recording/contact-us.php",
      "poi_directions_map_url": "https://maps.google.com/?cid=308360880799915468&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dallas-county-records-building",
      "poi_latitude": "32.7795115",
      "poi_longitude": "-96.8076272",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 214-653-7011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-aa60-700e-b8e6-9100206477af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-aa60-700e-b8e6-9100206477af",
        "storage_key": "property/5646289643503616/019f1501-aa60-700e-b8e6-9100206477af.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNYrHqJ-ZToYRzJ20WpaERwQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "ec_166b9d314ba181b4905cbb3e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "Renaissance Tower",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1201 Elm St, Dallas, TX 75201, USA",
      "poi_short_description": "Business center in the Renaissance Tower with eateries, a boutique, and a Starbucks.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1504-9ef3-721b-86f5-342efb0e944d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-9ef3-721b-86f5-342efb0e944d",
        "storage_key": "property/5646289643503616/019f1504-9ef3-721b-86f5-342efb0e944d.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=6750028751376732605&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "renaissance-tower",
      "poi_latitude": "32.7812514",
      "poi_longitude": "-96.8019422",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 214-571-6200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-aa8e-7615-b338-e4c75aa44be0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-aa8e-7615-b338-e4c75aa44be0",
        "storage_key": "property/5646289643503616/019f1501-aa8e-7615-b338-e4c75aa44be0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNbl1EhiZToYRvdF73WLrrF0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "business_center"
    },
    {
      "id": "ec_5688f3052755d2ba0dddf7fc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "American Airlines Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2500 Victory Ave, Dallas, TX 75219, USA",
      "poi_short_description": "Modern venue that hosts concerts by big-name acts and serves as the home ground of the Dallas Mavericks basketball team and Dallas Stars hockey team.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-7400-746d-bdc1-83f938e6f292.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-7400-746d-bdc1-83f938e6f292",
        "storage_key": "property/5646289643503616/019f1501-7400-746d-bdc1-83f938e6f292.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.americanairlinescenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2405235901812051875&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "american-airlines-center",
      "poi_latitude": "32.7903908",
      "poi_longitude": "-96.8102547",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 214-665-4299",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-aa8e-7615-b338-e4c75aa44be0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-aa8e-7615-b338-e4c75aa44be0",
        "storage_key": "property/5646289643503616/019f1501-aa8e-7615-b338-e4c75aa44be0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJr-XOXC-ZToYRow-GKE8dYSE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "ec_fab0f7f73ad48a3c4d4b15c2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "Baylor University Medical Center, part of Baylor Scott & White Health",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3500 Gaston Ave, Dallas, TX 75246, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1504-6f8b-7549-bf66-3c9d75c5d40a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-6f8b-7549-bf66-3c9d75c5d40a",
        "storage_key": "property/5646289643503616/019f1504-6f8b-7549-bf66-3c9d75c5d40a.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.bswhealth.com/locations/hospital/dallas?utm_content=main-website&utm_source=pg-google&utm_medium=organic&utm_campaign=29985-9717571",
      "poi_directions_map_url": "https://maps.google.com/?cid=1052454823151725673&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "baylor-university-medical-center-part-of-baylor-scott--white-health",
      "poi_latitude": "32.7904132",
      "poi_longitude": "-96.7799639",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 214-820-0111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-aa5b-73ea-b3ff-bd161122672d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-aa5b-73ea-b3ff-bd161122672d",
        "storage_key": "property/5646289643503616/019f1501-aa5b-73ea-b3ff-bd161122672d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJTZxCv8SYToYRaewa5BUSmw4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_5c093e3516e0761f04c0bf04",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "UT Southwestern Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5323 Harry Hines Blvd, Dallas, TX 75390, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1504-a9be-744e-8ac1-fe2dc22a3449.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-a9be-744e-8ac1-fe2dc22a3449",
        "storage_key": "property/5646289643503616/019f1504-a9be-744e-8ac1-fe2dc22a3449.webp",
        "width": 1050,
        "height": 695
      },
      "poi_business_url": "https://www.utswmed.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3342772861670659339&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ut-southwestern-medical-center",
      "poi_latitude": "32.8126061",
      "poi_longitude": "-96.8422515",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 214-648-3111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-aa5b-73ea-b3ff-bd161122672d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-aa5b-73ea-b3ff-bd161122672d",
        "storage_key": "property/5646289643503616/019f1501-aa5b-73ea-b3ff-bd161122672d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJmeWIsAScToYRCxWy-DTqYy4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "ec_46897891c8c26a8eeffa1526",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "Parkland Health",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5200 Harry Hines Blvd, Dallas, TX 75235, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-885b-70ac-ac99-2f612ab449c6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-885b-70ac-ac99-2f612ab449c6",
        "storage_key": "property/5646289643503616/019f1501-885b-70ac-ac99-2f612ab449c6.webp",
        "width": 940,
        "height": 788
      },
      "poi_business_url": "http://www.parklandhealth.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8882318995387276974&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "parkland-health",
      "poi_latitude": "32.8135637",
      "poi_longitude": "-96.8348",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 214-590-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-aa5b-73ea-b3ff-bd161122672d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-aa5b-73ea-b3ff-bd161122672d",
        "storage_key": "property/5646289643503616/019f1501-aa5b-73ea-b3ff-bd161122672d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJO6FKVW6dToYRrl7D1RBWRHs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "ec_0fe7caf86f5519edbfc7a59d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "poi_name": "Children's Medical Center Dallas",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1935 Medical District Dr, Dallas, TX 75235, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-84c5-72eb-95a0-171bd61efaa1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-84c5-72eb-95a0-171bd61efaa1",
        "storage_key": "property/5646289643503616/019f1501-84c5-72eb-95a0-171bd61efaa1.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.childrens.com/locations/dallas-campus/childrens-medical-center-dallas?utm_source=google?utm_medium=yext&utm_campaign=Children's%20Medical%20Center%20Dallas%20%7C%20%20%7C%20Brand",
      "poi_directions_map_url": "https://maps.google.com/?cid=18271839534167086103&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "childrens-medical-center-dallas",
      "poi_latitude": "32.8093936",
      "poi_longitude": "-96.8368333",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 214-456-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f1501-aa5b-73ea-b3ff-bd161122672d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-aa5b-73ea-b3ff-bd161122672d",
        "storage_key": "property/5646289643503616/019f1501-aa5b-73ea-b3ff-bd161122672d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJTeFHSgKcToYRF9T3ej-dkv0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    }
  ],
  "office_hours": [
    {
      "id": "custom_cb874bc2-ea90-427c-8824-2ccbeef6ecf4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_1af6e2c2-d508-4855-a772-d8ab480e3cec",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_19b9b7ec-8de2-44dd-bcaa-78595780207b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_0d6fbacc-7499-4fa5-9a9e-b5dee001e885",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_11686675-3b38-4c5c-92e0-8788cce68f90",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_57b8d3f6-acd5-4b91-8a04-6c87f1286a7a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_aa0f95b618b091ff60afded9",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "rating": "5",
      "name": "taylor warren",
      "text": "I came in to MacAllan needing to move in immediately. Stephanie the property manager was great and helped me get everything situated! I’m super excited excited to move in and very grateful for the support and welcoming energy🩷🩷",
      "date": "2026-02-24",
      "title": "false"
    },
    {
      "id": "ec_adbfa245b8c6b2a9e15489c0",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "rating": "4",
      "name": "Jack Sheppard",
      "text": "The office staff is five stars, especially Yecenia. You can always count on her to answer questions and help resolve any issues that come up. It seems like no matter what you ask, she has an answer or can find a solution.\n\nThe reason I’m giving four stars instead of five is because of the security concerns. The garage gate is broken, and the garage doors do not work, allowing someone to gain access to the building and use the facilities. That said, if you keep your apartment door locked, as you should anyway, there’s generally nothing to worry about.\n\nOverall, the staff and management are excellent, but the security issues keep it from being a five-star.",
      "date": "2026-06-09",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_9e84d4200a890a194eafca15",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "YouTube channel: American Landmark",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f14c3-f011-749a-9983-dd9a4020956d.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c3-f011-749a-9983-dd9a4020956d",
        "storage_key": "property/5646289643503616/019f14c3-f011-749a-9983-dd9a4020956d.webp",
        "width": 480,
        "height": 360
      },
      "virtual_tour_title": "Macallan on Ross - Community Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://www.youtube.com/embed/bT_W6ykcE7w"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa45-a8cf-7349-8370-8c7536dba1e2",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "macallan-on-ross",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616"
    },
    {
      "lead_collector_id": "0198aa45-a931-7324-aa41-a07458775aaf",
      "lead_source": "FACEBOOK_ADS",
      "name": "macallan-on-ross",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616"
    },
    {
      "lead_collector_id": "0198aa45-a995-7648-849f-02cf5af9aa4c",
      "lead_source": "LANDING_PAGE",
      "name": "macallan-on-ross",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "custom",
      "page_item_url": "discover-studio-apartments-rent-dallas-tx-macallan-ross",
      "search_query": "Studio Apartments For Rent In Dallas TX",
      "category": "Floorplan",
      "h1_title": "Discover Studio Apartments For Rent In Dallas TX at Macallan on Ross",
      "h2_subtitle": "Macallan on Ross offers a vibrant community with studio apartments designed for comfort and style. Enjoy modern amenities and a prime location in Dallas, TX.",
      "page_copy": "Welcome to Macallan on Ross, where studio apartments for rent in Dallas TX redefine urban living. Our community features spacious layouts and thoughtful amenities that make you feel right at home. Each studio apartment is equipped with high-speed internet access, stainless steel appliances, and quartz countertops, ensuring a modern and convenient lifestyle. Located at 3501 Ross Avenue, our residents enjoy easy access to the best of Dallas, TX. Whether you're relaxing in your vaulted ceiling apartment or taking in the views from your balcony, Macallan on Ross provides an exceptional living experience. Discover the perfect blend of comfort and convenience in our studio apartments today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f6c0f-c2a0-764b-8a2c-1a16a75a8356.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building entrance with glass windows and balconies, surrounded by colorful flowers.",
        "public_id": "019f6c0f-c2a0-764b-8a2c-1a16a75a8356",
        "storage_key": "property/5646289643503616/019f6c0f-c2a0-764b-8a2c-1a16a75a8356.webp",
        "width": 1498,
        "height": 848
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f6c0f-cbd1-7498-854b-2da12af0358a.webp",
      "blank_image_media": {
        "alt_text": "Black rectangle",
        "public_id": "019f6c0f-cbd1-7498-854b-2da12af0358a",
        "storage_key": "property/5646289643503616/019f6c0f-cbd1-7498-854b-2da12af0358a.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Macallan on Ross | Studio Apartments For Rent In Dallas TX",
      "seo_description": "Explore studio apartments for rent in Dallas TX at Macallan on Ross. Enjoy modern amenities and a prime location. Visit us at 3501 Ross Avenue, Dallas, TX.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "custom",
      "page_item_url": "find-one-bedroom-apartments-for-rent-dallas-tx-macallan-ross",
      "search_query": "One Bedroom Apartments For Rent In Dallas TX",
      "category": "Floorplan",
      "h1_title": "Find One Bedroom Apartments For Rent In Dallas TX at Macallan on Ross",
      "h2_subtitle": "Macallan on Ross presents one bedroom apartments that blend comfort and style. Experience modern living with top-notch amenities in the heart of Dallas, TX.",
      "page_copy": "Welcome to Macallan on Ross, your destination for one bedroom apartments for rent in Dallas TX. Our community offers spacious layouts and a range of amenities designed to enhance your living experience. Each one bedroom apartment features high-speed internet access, stainless steel appliances, and walk-in closets, providing both convenience and luxury. Situated at 3501 Ross Avenue, our location offers easy access to Dallas's vibrant city life. Whether you're enjoying the comfort of your air-conditioned apartment or the scenic views from your balcony, Macallan on Ross ensures a superior living environment. Discover the ideal combination of location and lifestyle in our one bedroom apartments today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f6c0f-c2a0-764b-8a2c-1a16a75a8356.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building entrance with glass windows and balconies, surrounded by colorful flowers.",
        "public_id": "019f6c0f-c2a0-764b-8a2c-1a16a75a8356",
        "storage_key": "property/5646289643503616/019f6c0f-c2a0-764b-8a2c-1a16a75a8356.webp",
        "width": 1498,
        "height": 848
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f6c0f-cbd1-7498-854b-2da12af0358a.webp",
      "blank_image_media": {
        "alt_text": "Black rectangle",
        "public_id": "019f6c0f-cbd1-7498-854b-2da12af0358a",
        "storage_key": "property/5646289643503616/019f6c0f-cbd1-7498-854b-2da12af0358a.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Macallan on Ross | One Bedroom Apartments For Rent In Dallas TX",
      "seo_description": "Discover one bedroom apartments for rent in Dallas TX at Macallan on Ross. Enjoy modern amenities and a prime location at 3501 Ross Avenue, Dallas, TX.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "custom",
      "page_item_url": "explore-two-bedrooms-apartments-for-rent-dallas-tx",
      "search_query": "Two Bedrooms Apartments For Rent In Dallas TX",
      "category": "Floorplan",
      "h1_title": "Explore Two Bedrooms Apartments For Rent In Dallas TX at Macallan on Ross",
      "h2_subtitle": "Macallan on Ross offers spacious two bedrooms apartments with modern amenities. Enjoy a prime location and exceptional living experience in Dallas, TX.",
      "page_copy": "Welcome to Macallan on Ross, where two bedrooms apartments for rent in Dallas TX offer the perfect blend of space and style. Our community features thoughtfully designed layouts and a host of amenities to enhance your lifestyle. Each two bedroom apartment includes high-speed internet access, stainless steel appliances, and walk-in closets, ensuring a comfortable and convenient living experience. Located at 3501 Ross Avenue, our residents enjoy easy access to the vibrant culture and attractions of Dallas, TX. Whether you're relaxing in your spacious living area or taking in the views from your balcony, Macallan on Ross provides an unparalleled living environment. Discover the ideal home for you in our two bedrooms apartments today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f6c0f-c2a0-764b-8a2c-1a16a75a8356.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building entrance with glass windows and balconies, surrounded by colorful flowers.",
        "public_id": "019f6c0f-c2a0-764b-8a2c-1a16a75a8356",
        "storage_key": "property/5646289643503616/019f6c0f-c2a0-764b-8a2c-1a16a75a8356.webp",
        "width": 1498,
        "height": 848
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f6c0f-cbd1-7498-854b-2da12af0358a.webp",
      "blank_image_media": {
        "alt_text": "Black rectangle",
        "public_id": "019f6c0f-cbd1-7498-854b-2da12af0358a",
        "storage_key": "property/5646289643503616/019f6c0f-cbd1-7498-854b-2da12af0358a.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Macallan on Ross | Two Bedrooms Apartments For Rent In Dallas TX",
      "seo_description": "Find two bedrooms apartments for rent in Dallas TX at Macallan on Ross. Enjoy modern amenities and a prime location at 3501 Ross Avenue, Dallas, TX.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-near-me-with-pool",
      "search_query": "Apartments For Rent Near Me with Pool",
      "category": "Amenity",
      "h1_title": "Discover Apartments For Rent Near Me with Pool at Macallan on Ross",
      "h2_subtitle": "Macallan on Ross offers luxurious apartments with a pool and modern amenities. Enjoy a vibrant community and exceptional service in a prime Dallas location.",
      "page_copy": "Welcome to Macallan on Ross, where apartments for rent near me with pool redefine luxury living. Our community features a stunning pool, perfect for relaxation and leisure. Alongside the pool, residents enjoy access to a state-of-the-art fitness center, a pet play area, and a business center, ensuring a well-rounded lifestyle. Located at 3501 Ross Avenue, our apartments offer easy access to public transportation and the vibrant culture of Dallas, TX. Whether you're lounging by the pool or enjoying the comfort of your spacious apartment, Macallan on Ross provides an exceptional living experience. Discover the perfect home with a pool and more in our community today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f6c0f-c2a0-764b-8a2c-1a16a75a8356.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building entrance with glass windows and balconies, surrounded by colorful flowers.",
        "public_id": "019f6c0f-c2a0-764b-8a2c-1a16a75a8356",
        "storage_key": "property/5646289643503616/019f6c0f-c2a0-764b-8a2c-1a16a75a8356.webp",
        "width": 1498,
        "height": 848
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f6c0f-cbd1-7498-854b-2da12af0358a.webp",
      "blank_image_media": {
        "alt_text": "Black rectangle",
        "public_id": "019f6c0f-cbd1-7498-854b-2da12af0358a",
        "storage_key": "property/5646289643503616/019f6c0f-cbd1-7498-854b-2da12af0358a.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Macallan on Ross | Apartments For Rent Near Me with Pool",
      "seo_description": "Explore apartments for rent near me with pool at Macallan on Ross. Enjoy modern amenities and a prime location at 3501 Ross Avenue, Dallas, TX.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-near-me-with-fitness-center",
      "search_query": "Apartments For Rent Near Me with Fitness Center",
      "category": "Amenity",
      "h1_title": "Find Apartments For Rent Near Me with Fitness Center at Macallan on Ross",
      "h2_subtitle": "Macallan on Ross offers apartments with a state-of-the-art fitness center and modern amenities. Enjoy a vibrant community in a prime Dallas location.",
      "page_copy": "Welcome to Macallan on Ross, where apartments for rent near me with fitness center offer a perfect blend of convenience and luxury. Our community features a fully equipped fitness center, ideal for maintaining an active lifestyle. In addition to the fitness center, residents enjoy amenities such as a pool, business center, and pet play area, ensuring a comprehensive living experience. Located at 3501 Ross Avenue, our apartments provide easy access to public transportation and the dynamic culture of Dallas, TX. Whether you're working out in the fitness center or relaxing in your spacious apartment, Macallan on Ross delivers an exceptional living environment. Discover your ideal home with a fitness center and more in our community today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f6c0f-c2a0-764b-8a2c-1a16a75a8356.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building entrance with glass windows and balconies, surrounded by colorful flowers.",
        "public_id": "019f6c0f-c2a0-764b-8a2c-1a16a75a8356",
        "storage_key": "property/5646289643503616/019f6c0f-c2a0-764b-8a2c-1a16a75a8356.webp",
        "width": 1498,
        "height": 848
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f6c0f-cbd1-7498-854b-2da12af0358a.webp",
      "blank_image_media": {
        "alt_text": "Black rectangle",
        "public_id": "019f6c0f-cbd1-7498-854b-2da12af0358a",
        "storage_key": "property/5646289643503616/019f6c0f-cbd1-7498-854b-2da12af0358a.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Macallan on Ross | Apartments For Rent Near Me with Fitness Center",
      "seo_description": "Explore apartments for rent near me with fitness center at Macallan on Ross. Enjoy modern amenities and a prime location at 3501 Ross Avenue, Dallas, TX.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-near-me-lounge-macallan-ross",
      "search_query": "Apartments For Rent Near Me with Lounge",
      "category": "Amenity",
      "h1_title": "Discover Apartments For Rent Near Me with Lounge at Macallan on Ross",
      "h2_subtitle": "Macallan on Ross offers apartments with a stylish lounge and modern amenities. Enjoy a vibrant community and exceptional service in a prime Dallas location.",
      "page_copy": "Welcome to Macallan on Ross, where apartments for rent near me with lounge provide a perfect blend of comfort and style. Our community features a chic lounge, ideal for socializing and relaxation. Alongside the lounge, residents enjoy amenities such as a pool, fitness center, and business center, ensuring a well-rounded living experience. Located at 3501 Ross Avenue, our apartments offer easy access to public transportation and the vibrant culture of Dallas, TX. Whether you're unwinding in the lounge or enjoying the comfort of your spacious apartment, Macallan on Ross provides an exceptional living environment. Discover your ideal home with a lounge and more in our community today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f6c0f-c2a0-764b-8a2c-1a16a75a8356.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building entrance with glass windows and balconies, surrounded by colorful flowers.",
        "public_id": "019f6c0f-c2a0-764b-8a2c-1a16a75a8356",
        "storage_key": "property/5646289643503616/019f6c0f-c2a0-764b-8a2c-1a16a75a8356.webp",
        "width": 1498,
        "height": 848
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f6c0f-cbd1-7498-854b-2da12af0358a.webp",
      "blank_image_media": {
        "alt_text": "Black rectangle",
        "public_id": "019f6c0f-cbd1-7498-854b-2da12af0358a",
        "storage_key": "property/5646289643503616/019f6c0f-cbd1-7498-854b-2da12af0358a.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Macallan on Ross | Apartments For Rent Near Me with Lounge",
      "seo_description": "Explore apartments for rent near me with lounge at Macallan on Ross. Enjoy modern amenities and a prime location at 3501 Ross Avenue, Dallas, TX.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-near-me-with-pet-play-area",
      "search_query": "Apartments For Rent Near Me with Pet Play Area",
      "category": "Amenity",
      "h1_title": "Find Apartments For Rent Near Me with Pet Play Area at Macallan on Ross",
      "h2_subtitle": "Macallan on Ross offers pet-friendly apartments with a dedicated pet play area. Enjoy a vibrant community and exceptional amenities in a prime Dallas location.",
      "page_copy": "Welcome to Macallan on Ross, where apartments for rent near me with pet play area cater to both you and your furry friends. Our community features a dedicated pet play area, perfect for your pets to enjoy and socialize. Alongside the pet play area, residents benefit from amenities such as a pool, fitness center, and business center, ensuring a comprehensive living experience. Located at 3501 Ross Avenue, our apartments provide easy access to public transportation and the dynamic culture of Dallas, TX. Whether you're playing with your pet or relaxing in your spacious apartment, Macallan on Ross offers an exceptional living environment. Discover your ideal home with a pet play area and more in our community today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f6c0f-c2a0-764b-8a2c-1a16a75a8356.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building entrance with glass windows and balconies, surrounded by colorful flowers.",
        "public_id": "019f6c0f-c2a0-764b-8a2c-1a16a75a8356",
        "storage_key": "property/5646289643503616/019f6c0f-c2a0-764b-8a2c-1a16a75a8356.webp",
        "width": 1498,
        "height": 848
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f6c0f-cbd1-7498-854b-2da12af0358a.webp",
      "blank_image_media": {
        "alt_text": "Black rectangle",
        "public_id": "019f6c0f-cbd1-7498-854b-2da12af0358a",
        "storage_key": "property/5646289643503616/019f6c0f-cbd1-7498-854b-2da12af0358a.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Macallan on Ross | Apartments For Rent Near Me with Pet Play Area",
      "seo_description": "Explore apartments for rent near me with pet play area at Macallan on Ross. Enjoy modern amenities and a prime location at 3501 Ross Avenue, Dallas, TX.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-near-public-transport",
      "search_query": "Apartments For Rent Near Public Transportation",
      "category": "Amenity",
      "h1_title": "Discover Apartments For Rent Near Public Transportation at Macallan on Ross",
      "h2_subtitle": "Macallan on Ross offers convenient apartments with access to public transportation. Enjoy a vibrant community and exceptional amenities in a prime Dallas location.",
      "page_copy": "Welcome to Macallan on Ross. Our community is ideally situated to provide easy access to public transportation, making commuting a breeze. In addition to this prime location, residents enjoy amenities such as a pool, fitness center, and business center, ensuring a well-rounded living experience. Located at 3501 Ross Avenue, our apartments are perfectly positioned to enjoy the vibrant culture and attractions of Dallas, TX. Whether you're commuting or relaxing in your spacious apartment, Macallan on Ross provides an exceptional living environment. Discover your ideal home with public transportation access and more in our community today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f6c0f-c2a0-764b-8a2c-1a16a75a8356.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building entrance with glass windows and balconies, surrounded by colorful flowers.",
        "public_id": "019f6c0f-c2a0-764b-8a2c-1a16a75a8356",
        "storage_key": "property/5646289643503616/019f6c0f-c2a0-764b-8a2c-1a16a75a8356.webp",
        "width": 1498,
        "height": 848
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f6c0f-cbd1-7498-854b-2da12af0358a.webp",
      "blank_image_media": {
        "alt_text": "Black rectangle",
        "public_id": "019f6c0f-cbd1-7498-854b-2da12af0358a",
        "storage_key": "property/5646289643503616/019f6c0f-cbd1-7498-854b-2da12af0358a.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Macallan on Ross | Apartments For Rent Near Public Transportation",
      "seo_description": "Explore apartments for rent near public transportation at Macallan on Ross. Enjoy modern amenities and a prime location in Dallas, TX.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-near-me-with-storage-space",
      "search_query": "Apartments For Rent with Storage Space",
      "category": "Amenity",
      "h1_title": "Find Apartments For Rent with Storage Space at Macallan on Ross",
      "h2_subtitle": "Macallan on Ross offers spacious apartments with ample storage space. Enjoy modern amenities and a prime location in the heart of Dallas, TX.",
      "page_copy": "Welcome to Macallan on Ross, where apartments for rent near me with storage space provide the perfect solution for your organizational needs. Our community features ample storage space within each apartment, ensuring you have room for all your belongings. Alongside generous storage, residents enjoy amenities such as high-speed internet access, stainless steel appliances, and walk-in closets, enhancing your living experience. Located at 3501 Ross Avenue, our apartments offer easy access to the vibrant culture and attractions of Dallas, TX. Whether you're organizing your space or relaxing in your comfortable apartment, Macallan on Ross provides an exceptional living environment. Discover your ideal home with storage space and more in our community today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f6c0f-c2a0-764b-8a2c-1a16a75a8356.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building entrance with glass windows and balconies, surrounded by colorful flowers.",
        "public_id": "019f6c0f-c2a0-764b-8a2c-1a16a75a8356",
        "storage_key": "property/5646289643503616/019f6c0f-c2a0-764b-8a2c-1a16a75a8356.webp",
        "width": 1498,
        "height": 848
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f6c0f-cbd1-7498-854b-2da12af0358a.webp",
      "blank_image_media": {
        "alt_text": "Black rectangle",
        "public_id": "019f6c0f-cbd1-7498-854b-2da12af0358a",
        "storage_key": "property/5646289643503616/019f6c0f-cbd1-7498-854b-2da12af0358a.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Macallan on Ross | Apartments For Rent with Storage Space",
      "seo_description": "Explore apartments for rent near me with storage space at Macallan on Ross. Enjoy modern amenities and a prime location in Dallas, TX.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-near-me-island-kitchen",
      "search_query": "Apartments For Rent Near Me with Island Kitchen",
      "category": "Amenity",
      "h1_title": "Discover Apartments For Rent Near Me with Island Kitchen at Macallan on Ross",
      "h2_subtitle": "Macallan on Ross offers modern apartments with stylish island kitchens. Enjoy a vibrant community and exceptional amenities in a prime Dallas location.",
      "page_copy": "Welcome to Macallan on Ross, where apartments for rent near me with island kitchen redefine culinary convenience and style. Our community features beautifully designed island kitchens, perfect for cooking and entertaining. Alongside the island kitchen, residents enjoy amenities such as quartz countertops, stainless steel appliances, and high-speed internet access, ensuring a modern and comfortable lifestyle. Located at 3501 Ross Avenue, our apartments provide easy access to the vibrant culture and attractions of Dallas, TX. Whether you're preparing a meal in your island kitchen or relaxing in your spacious apartment, Macallan on Ross offers an exceptional living environment. Discover your ideal home with an island kitchen and more in our community today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f6c0f-c2a0-764b-8a2c-1a16a75a8356.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building entrance with glass windows and balconies, surrounded by colorful flowers.",
        "public_id": "019f6c0f-c2a0-764b-8a2c-1a16a75a8356",
        "storage_key": "property/5646289643503616/019f6c0f-c2a0-764b-8a2c-1a16a75a8356.webp",
        "width": 1498,
        "height": 848
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f6c0f-cbd1-7498-854b-2da12af0358a.webp",
      "blank_image_media": {
        "alt_text": "Black rectangle",
        "public_id": "019f6c0f-cbd1-7498-854b-2da12af0358a",
        "storage_key": "property/5646289643503616/019f6c0f-cbd1-7498-854b-2da12af0358a.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Macallan on Ross | Apartments For Rent Near Me with Island Kitchen",
      "seo_description": "Explore apartments for rent near me with island kitchen at Macallan on Ross. Enjoy modern amenities and a prime location at 3501 Ross Avenue, Dallas, TX.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-near-me-quartz-countertops",
      "search_query": "Apartments For Rent Near Me with Quartz Countertops",
      "category": "Amenity",
      "h1_title": "Find Apartments For Rent Near Me with Quartz Countertops at Macallan on Ross",
      "h2_subtitle": "Macallan on Ross offers luxurious apartments with elegant quartz countertops. Enjoy modern amenities and a prime location in the heart of Dallas, TX.",
      "page_copy": "Welcome to Macallan on Ross, where apartments for rent near me with quartz countertops offer a touch of elegance and durability. Our community features beautifully crafted quartz countertops in each apartment, providing a sleek and modern kitchen experience. Alongside the quartz countertops, residents enjoy amenities such as stainless steel appliances, high-speed internet access, and spacious layouts, ensuring a comfortable and stylish living environment. Located at 3501 Ross Avenue, our apartments offer easy access to the vibrant culture and attractions of Dallas, TX. Whether you're cooking in your modern kitchen or relaxing in your spacious apartment, Macallan on Ross provides an exceptional living experience. Discover your ideal home with quartz countertops and more in our community today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f6c0f-c2a0-764b-8a2c-1a16a75a8356.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building entrance with glass windows and balconies, surrounded by colorful flowers.",
        "public_id": "019f6c0f-c2a0-764b-8a2c-1a16a75a8356",
        "storage_key": "property/5646289643503616/019f6c0f-c2a0-764b-8a2c-1a16a75a8356.webp",
        "width": 1498,
        "height": 848
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f6c0f-cbd1-7498-854b-2da12af0358a.webp",
      "blank_image_media": {
        "alt_text": "Black rectangle",
        "public_id": "019f6c0f-cbd1-7498-854b-2da12af0358a",
        "storage_key": "property/5646289643503616/019f6c0f-cbd1-7498-854b-2da12af0358a.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Macallan on Ross | Apartments For Rent Near Me with Quartz Countertops",
      "seo_description": "Explore apartments for rent near me with quartz countertops at Macallan on Ross. Enjoy modern amenities and a prime location at 3501 Ross Avenue, Dallas, TX.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-near-me-with-high-speed-internet",
      "search_query": "Apartments For Rent Near Me with High Speed Internet Access",
      "category": "Amenity",
      "h1_title": "Discover Apartments For Rent Near Me with High Speed Internet Access at Macallan on Ross",
      "h2_subtitle": "Macallan on Ross offers modern apartments with high speed internet access. Enjoy a vibrant community and exceptional amenities in a prime Dallas location.",
      "page_copy": "Welcome to Macallan on Ross, where apartments for rent near me with high speed internet access ensure you stay connected seamlessly. Our community features high speed internet access in every apartment, perfect for work, study, or entertainment. Alongside this essential amenity, residents enjoy features such as stainless steel appliances, spacious layouts, and quartz countertops, providing a modern and comfortable living environment. Located at 3501 Ross Avenue, our apartments offer easy access to the vibrant culture and attractions of Dallas, TX. Whether you're working from home or streaming your favorite shows, Macallan on Ross provides an exceptional living experience. Discover your ideal home with high speed internet access and more in our community today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f6c0f-c2a0-764b-8a2c-1a16a75a8356.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building entrance with glass windows and balconies, surrounded by colorful flowers.",
        "public_id": "019f6c0f-c2a0-764b-8a2c-1a16a75a8356",
        "storage_key": "property/5646289643503616/019f6c0f-c2a0-764b-8a2c-1a16a75a8356.webp",
        "width": 1498,
        "height": 848
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f6c0f-cbd1-7498-854b-2da12af0358a.webp",
      "blank_image_media": {
        "alt_text": "Black rectangle",
        "public_id": "019f6c0f-cbd1-7498-854b-2da12af0358a",
        "storage_key": "property/5646289643503616/019f6c0f-cbd1-7498-854b-2da12af0358a.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Macallan on Ross | Apartments For Rent Near Me with High Speed Internet Access",
      "seo_description": "Explore apartments for rent near me with high speed internet access at Macallan on Ross. Enjoy modern amenities and a prime location at 3501 Ross Avenue, Dallas, TX.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-near-me-with-wi-fi",
      "search_query": "Apartments For Rent with Wi-Fi",
      "category": "Amenity",
      "h1_title": "Find Apartments For Rent with Wi-Fi at Macallan on Ross",
      "h2_subtitle": "Macallan on Ross offers modern apartments with convenient Wi-Fi access. Enjoy a vibrant community and exceptional amenities in a prime Dallas location.",
      "page_copy": "Welcome to Macallan on Ross, where apartments for rent near me with Wi-Fi keep you connected effortlessly. Our community provides Wi-Fi access in every apartment, ensuring seamless connectivity for work, study, or leisure. Alongside Wi-Fi, residents enjoy features such as stainless steel appliances, spacious layouts, and quartz countertops, creating a modern and comfortable living environment. Located at 3501 Ross Avenue, our apartments offer easy access to the vibrant culture and attractions of Dallas, TX. Whether you're working from home or streaming your favorite content, Macallan on Ross provides an exceptional living experience. Discover your ideal home with Wi-Fi and more in our community today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f6c0f-c2a0-764b-8a2c-1a16a75a8356.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building entrance with glass windows and balconies, surrounded by colorful flowers.",
        "public_id": "019f6c0f-c2a0-764b-8a2c-1a16a75a8356",
        "storage_key": "property/5646289643503616/019f6c0f-c2a0-764b-8a2c-1a16a75a8356.webp",
        "width": 1498,
        "height": 848
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f6c0f-cbd1-7498-854b-2da12af0358a.webp",
      "blank_image_media": {
        "alt_text": "Black rectangle",
        "public_id": "019f6c0f-cbd1-7498-854b-2da12af0358a",
        "storage_key": "property/5646289643503616/019f6c0f-cbd1-7498-854b-2da12af0358a.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Macallan on Ross | Apartments For Rent with Wi-Fi",
      "seo_description": "Explore apartments for rent with Wi-Fi at Macallan on Ross. Enjoy modern amenities and a prime location in Dallas, TX.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-dallas-tx-near-baylor-university",
      "search_query": "Apartments For Rent In Dallas TX Near Baylor University",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent In Dallas TX Near Baylor University ",
      "h2_subtitle": "Macallan on Ross offers convenient living near Baylor University. Enjoy modern amenities and a prime Dallas location.",
      "page_copy": "Welcome to Macallan on Ross, where apartments for rent in Dallas TX near Baylor University, offer unmatched convenience and comfort. Our community is ideally located just east of downtown, providing easy access to one of the nation's top medical centers. Residents enjoy spacious layouts and thoughtful amenities, including high-speed internet access, stainless steel appliances, and a fitness center, ensuring a modern and comfortable lifestyle. Situated at 3501 Ross Avenue, our apartments offer easy access to public transportation and the vibrant culture of Dallas, TX. Whether you're working at the medical center or enjoying the comfort of your apartment, Macallan on Ross provides an exceptional living experience. Discover your ideal home near Baylor University Medical Center today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f6c0f-c2a0-764b-8a2c-1a16a75a8356.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building entrance with glass windows and balconies, surrounded by colorful flowers.",
        "public_id": "019f6c0f-c2a0-764b-8a2c-1a16a75a8356",
        "storage_key": "property/5646289643503616/019f6c0f-c2a0-764b-8a2c-1a16a75a8356.webp",
        "width": 1498,
        "height": 848
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f6c0f-cbd1-7498-854b-2da12af0358a.webp",
      "blank_image_media": {
        "alt_text": "Black rectangle",
        "public_id": "019f6c0f-cbd1-7498-854b-2da12af0358a",
        "storage_key": "property/5646289643503616/019f6c0f-cbd1-7498-854b-2da12af0358a.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Macallan on Ross | Apartments For Rent In Dallas TX Near Baylor University ",
      "seo_description": "Explore apartments for rent in Dallas TX near Baylor University Medical Center at Macallan on Ross. Enjoy modern amenities and a prime location at 3501 Ross Avenue, Dallas, TX.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-dallas-tx-university",
      "search_query": "Apartments For Rent In Dallas TX Near The University of Texas at Dallas",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent In Dallas TX Near The University of Texas at Dallas at Macallan on Ross",
      "h2_subtitle": "Macallan on Ross offers convenient living near The University of Texas at Dallas. Enjoy modern amenities and a prime location in the heart of Dallas, TX.",
      "page_copy": "Welcome to Macallan on Ross, where apartments for rent in Dallas TX near The University of Texas at Dallas provide the perfect blend of convenience and comfort. Our community is ideally located, offering easy access to this prestigious university known for its academic excellence and vibrant campus life. Residents enjoy spacious layouts and thoughtful amenities, including high-speed internet access, stainless steel appliances, and a fitness center, ensuring a modern and comfortable lifestyle. Situated at 3501 Ross Avenue, our apartments offer easy access to public transportation and the vibrant culture of Dallas, TX. Whether you're studying at the university or enjoying the comfort of your apartment, Macallan on Ross provides an exceptional living experience. Discover your ideal home near The University of Texas at Dallas today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f6c0f-c2a0-764b-8a2c-1a16a75a8356.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building entrance with glass windows and balconies, surrounded by colorful flowers.",
        "public_id": "019f6c0f-c2a0-764b-8a2c-1a16a75a8356",
        "storage_key": "property/5646289643503616/019f6c0f-c2a0-764b-8a2c-1a16a75a8356.webp",
        "width": 1498,
        "height": 848
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f6c0f-cbd1-7498-854b-2da12af0358a.webp",
      "blank_image_media": {
        "alt_text": "Black rectangle",
        "public_id": "019f6c0f-cbd1-7498-854b-2da12af0358a",
        "storage_key": "property/5646289643503616/019f6c0f-cbd1-7498-854b-2da12af0358a.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Macallan on Ross | Apartments For Rent In Dallas TX Near The University of Texas at Dallas",
      "seo_description": "Explore apartments for rent in Dallas TX near The University of Texas at Dallas at Macallan on Ross. Enjoy modern amenities and a prime location at 3501 Ross Avenue, Dallas, TX.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-near-dallas-college",
      "search_query": "Apartments For Rent In Dallas TX Near Dallas College El Centro Campus",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent In Dallas TX Near Dallas College El Centro Campus at Macallan on Ross",
      "h2_subtitle": "Macallan on Ross offers convenient living near Dallas College El Centro Campus. Enjoy modern amenities and a prime location in the heart of Dallas, TX.",
      "page_copy": "Welcome to Macallan on Ross, where apartments for rent in Dallas TX near Dallas College El Centro Campus provide the perfect blend of convenience and comfort. Our community is ideally located, offering easy access to this central educational hub known for its diverse programs and vibrant student life. Residents enjoy spacious layouts and thoughtful amenities, including high-speed internet access, stainless steel appliances, and a fitness center, ensuring a modern and comfortable lifestyle. Situated at 3501 Ross Avenue, our apartments offer easy access to public transportation and the vibrant culture of Dallas, TX. Whether you're studying at El Centro or enjoying the comfort of your apartment, Macallan on Ross provides an exceptional living experience. Discover your ideal home near Dallas College El Centro Campus today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f6c0f-c2a0-764b-8a2c-1a16a75a8356.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building entrance with glass windows and balconies, surrounded by colorful flowers.",
        "public_id": "019f6c0f-c2a0-764b-8a2c-1a16a75a8356",
        "storage_key": "property/5646289643503616/019f6c0f-c2a0-764b-8a2c-1a16a75a8356.webp",
        "width": 1498,
        "height": 848
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f6c0f-cbd1-7498-854b-2da12af0358a.webp",
      "blank_image_media": {
        "alt_text": "Black rectangle",
        "public_id": "019f6c0f-cbd1-7498-854b-2da12af0358a",
        "storage_key": "property/5646289643503616/019f6c0f-cbd1-7498-854b-2da12af0358a.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Macallan on Ross | Apartments For Rent In Dallas TX Near Dallas College El Centro Campus",
      "seo_description": "Explore apartments for rent in Dallas TX near Dallas College El Centro Campus at Macallan on Ross. Enjoy modern amenities and a prime location at 3501 Ross Avenue, Dallas, TX.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-near-dallas-baptist-univ",
      "search_query": "Apartments For Rent In Dallas TX Near Dallas Baptist University",
      "category": "POI",
      "h1_title": "Find Apartments For Rent In Dallas TX Near Dallas Baptist University at Macallan on Ross",
      "h2_subtitle": "Macallan on Ross offers convenient living near Dallas Baptist University. Enjoy modern amenities and a prime location in the heart of Dallas, TX.",
      "page_copy": "Welcome to Macallan on Ross, where apartments for rent in Dallas TX near Dallas Baptist University provide the perfect blend of convenience and comfort. Our community is ideally located, offering easy access to this esteemed university known for its strong academic programs and vibrant campus life. Residents enjoy spacious layouts and thoughtful amenities, including high-speed internet access, stainless steel appliances, and a fitness center, ensuring a modern and comfortable lifestyle. Situated at 3501 Ross Avenue, our apartments offer easy access to public transportation and the vibrant culture of Dallas, TX. Whether you're studying at the university or enjoying the comfort of your apartment, Macallan on Ross provides an exceptional living experience. Discover your ideal home near Dallas Baptist University today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f6c0f-c2a0-764b-8a2c-1a16a75a8356.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building entrance with glass windows and balconies, surrounded by colorful flowers.",
        "public_id": "019f6c0f-c2a0-764b-8a2c-1a16a75a8356",
        "storage_key": "property/5646289643503616/019f6c0f-c2a0-764b-8a2c-1a16a75a8356.webp",
        "width": 1498,
        "height": 848
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f6c0f-cbd1-7498-854b-2da12af0358a.webp",
      "blank_image_media": {
        "alt_text": "Black rectangle",
        "public_id": "019f6c0f-cbd1-7498-854b-2da12af0358a",
        "storage_key": "property/5646289643503616/019f6c0f-cbd1-7498-854b-2da12af0358a.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Macallan on Ross | Apartments For Rent In Dallas TX Near Dallas Baptist University",
      "seo_description": "Explore apartments for rent in Dallas TX near Dallas Baptist University at Macallan on Ross. Enjoy modern amenities and a prime location at 3501 Ross Avenue, Dallas, TX.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-dallas-tx-near-booker-t-washington",
      "search_query": "Apartments For Rent In Dallas TX Near Booker T. Washington High School",
      "category": "POI",
      "h1_title": "Find Apartments For Rent In Dallas TX Near Booker T. Washington High School ",
      "h2_subtitle": "Macallan on Ross offers family-friendly living just 1.6 km from Booker T. Washington High School . Enjoy spacious floor plans and modern amenities in a prime Dallas location.",
      "page_copy": "Welcome to Macallan on Ross, where apartments for rent in Dallas TX near Booker T. Washington High School for the Performing and Visual Arts provide the perfect home for families. Located just 1.6 km away, our community offers convenient access to this renowned arts magnet school, preparing students for college, conservatory, or artistic careers. Families can choose from studio, one, and two bedroom floor plans, each designed with spacious layouts and thoughtful amenities. Our apartments feature high-speed internet access, stainless steel appliances, and walk-in closets, ensuring a comfortable and modern lifestyle. Situated at 3501 Ross Avenue, our community also offers family-friendly amenities such as a pet play area, pool, and courtyard. Discover your ideal family home near Booker T. Washington High School for the Performing and Visual Arts at Macallan on Ross today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f6c0f-c2a0-764b-8a2c-1a16a75a8356.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building entrance with glass windows and balconies, surrounded by colorful flowers.",
        "public_id": "019f6c0f-c2a0-764b-8a2c-1a16a75a8356",
        "storage_key": "property/5646289643503616/019f6c0f-c2a0-764b-8a2c-1a16a75a8356.webp",
        "width": 1498,
        "height": 848
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f6c0f-cbd1-7498-854b-2da12af0358a.webp",
      "blank_image_media": {
        "alt_text": "Black rectangle",
        "public_id": "019f6c0f-cbd1-7498-854b-2da12af0358a",
        "storage_key": "property/5646289643503616/019f6c0f-cbd1-7498-854b-2da12af0358a.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Macallan on Ross | Apartments For Rent In Dallas TX Near Booker T. Washington High School ",
      "seo_description": "Explore family-friendly apartments for rent in Dallas TX near Booker T. Washington High School at Macallan on Ross. Enjoy modern amenities and a prime location at 3501 Ross Avenue, Dallas, TX.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5646289643503616",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-in-dallas-tx-near-macallan-on-ross",
      "search_query": "Apartments For Rent In Dallas TX ",
      "category": "POI",
      "h1_title": "Find Apartments For Rent In Dallas TX near Macallan on Ross",
      "h2_subtitle": "Macallan on Ross offers family-friendly living just 5.7 km from the heart of Dallas. Enjoy spacious floor plans and modern amenities in a prime Dallas location.",
      "page_copy": "Welcome to Macallan on Ross, where apartments for rent in Dallas TX near the vibrant city of Dallas provide the perfect home for families. Located just 5.7 km away, our community offers convenient access to the bustling city life and amenities of the Dallas–Fort Worth metroplex, the most populous metropolitan area in Texas. Families can choose from studio, one, and two bedroom floor plans, each designed with spacious layouts and thoughtful amenities. Our apartments feature high-speed internet access, stainless steel appliances, and walk-in closets, ensuring a comfortable and modern lifestyle. Situated at 3501 Ross Avenue, our community also offers family-friendly amenities such as a pet play area, pool, and courtyard. Discover your ideal family home near the heart of Dallas at Macallan on Ross today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f6c0f-c2a0-764b-8a2c-1a16a75a8356.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building entrance with glass windows and balconies, surrounded by colorful flowers.",
        "public_id": "019f6c0f-c2a0-764b-8a2c-1a16a75a8356",
        "storage_key": "property/5646289643503616/019f6c0f-c2a0-764b-8a2c-1a16a75a8356.webp",
        "width": 1498,
        "height": 848
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019f6c0f-cbd1-7498-854b-2da12af0358a.webp",
      "blank_image_media": {
        "alt_text": "Black rectangle",
        "public_id": "019f6c0f-cbd1-7498-854b-2da12af0358a",
        "storage_key": "property/5646289643503616/019f6c0f-cbd1-7498-854b-2da12af0358a.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Macallan on Ross | Apartments For Rent In Dallas TX",
      "seo_description": "Explore family-friendly apartments for rent in Dallas TX near Macallan on Ross. Enjoy modern amenities and a prime location in Dallas, TX.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "2175"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "2376470942"
    },
    {
      "ID": "custom_leasing_ai",
      "type": "STRING",
      "value": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a38\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a38\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4810272"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-T6WBS9L"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "2"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "3165"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "8443251724"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "c7747694813511f1"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "1f195820242ac1100a1b122d7087a021"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/1ywyj8d7wq0"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/e534bc0d-2699-4114-a3fe-4b36308592ad"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "817-442-2715"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6InZQT3Fvbm9oQ0hLM2FJbWNIbXAxTkE9PSIsInZhbHVlIjoiWmxVSUI5QmVhd0ttU3ZmbytmZEZ5dz09IiwibWFjIjoiNWQ1YmFiMDY1MjAwMWEwYTAwMTYxMDkyMjg5YjAzODI2ZDljYWQ5NjhlZjM3ZmQ4Y2JmOGNhMjkzM2EzMjUxMSJ9"
    },
    {
      "ID": "custom_household_income_qualification_multiplier",
      "type": "FLOAT",
      "value": "3"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "2175",
  "custom_repli_id": "2376470942",
  "custom_leasing_ai": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a38\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a38\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />",
  "custom_realpage_id": "4810272",
  "custom_google_gtm_id": "GTM-T6WBS9L",
  "custom_rollout_phase": "2",
  "custom_ads_subscription": "full_stack",
  "custom_knock_company_id": "3165",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "8443251724",
  "custom_knock_community_id": "c7747694813511f1",
  "custom_knock_company_token": "1f195820242ac1100a1b122d7087a021",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/1ywyj8d7wq0",
  "custom_self_guided_tour_url": "https://selftournow.com/property/e534bc0d-2699-4114-a3fe-4b36308592ad",
  "custom_website_subscription": "custom",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_ppc_tracking_phone_number": "817-442-2715",
  "custom_apartmentsync_javascript_id": "eyJpdiI6InZQT3Fvbm9oQ0hLM2FJbWNIbXAxTkE9PSIsInZhbHVlIjoiWmxVSUI5QmVhd0ttU3ZmbytmZEZ5dz09IiwibWFjIjoiNWQ1YmFiMDY1MjAwMWEwYTAwMTYxMDkyMjg5YjAzODI2ZDljYWQ5NjhlZjM3ZmQ4Y2JmOGNhMjkzM2EzMjUxMSJ9",
  "custom_household_income_qualification_multiplier": "3"
};

export const generatedAt = '2026-11-02T21:24:47.609Z';
